/** @flow */

export const reportingMessages = {
  en: {
    REPORT_CREATED: "Report sucessfully created!",
    REPORT_UPDATED: "Report was successfully updated",
    REFERRAL_UPDATED: "Referral status updated",
    MI_PRESENTATION_CREATED: "MI Presentation successfully created!",
    MI_PRESENTATION_UPDATED: "MI Presentation successfully updated!",
    MI_PRESENTATION_SHARED: "MI Presentation shared successfully!",
    RTW_INTERVIEW_SAVED: "RTW Interview draft was successfully saved",
    RTW_INTERVIEW_SUBMITTED: "RTW Interview was successfully submitted",
    NOTIFICATION_APPROVED_SUCCESS: "Notification was successfully approved",
    NOTIFICATION_BLOCKED_SUCCESS: "Notification was successfully blocked",
    KPI_COMPLIANCE_REPORT_EXPORT_SUCCESS: "KPI Compliance report was successfully exported",
    TREND_ABSENCE_RATE_BREAKDOWN_EXPORT_SUCCESS:
      "Trend Absence Rate report Breakdown was successfully exported",
  },
};

export default {
  en: {
    // shared
    DEPARTMENT_ABSENCE_FROM: "Department Absence From",
    SPELLS_LOST_IN_LAST_12_MONTHS: "Spells in Last 12 Months",
    FIT_AT: "Fit At",
    TOTAL_DLPE: "Total DLPE",
    CALENDAR_DAY_UP_TO_FIT_DAY: "Calendar Day Up To Fit Date",
    HIERARCHY_LEVEL_2: "Hierarchy Level 2",
    HIERARCHY_LEVEL_3: "Hierarchy Level 3",
    HIERARCHY_LEVEL_4: "Hierarchy Level 4",
    DAYS_LOST_IN_PERIOD: "Days Lost in Period",
    HOURS_LOST_IN_PERIOD: "Hours Lost in Period",
    CALENDAR_DAYS_LOST_IN_PERIOD: "Calendar Days Lost in Period",
    CALENDAR_DAY_UP_TO_FIT_DATE: "Calendar Day Up To Fit Date",

    CANCEL_TASK: "Cancel Task",
    CANCEL_TASK_MODAL_QUESTION: "Are you sure you want to cancel this task ?",
    NEW_REPORT_NAME: "New Report Name",
    REPORT_NAME: "Report Name",
    REPORT_TYPE: "Report Type",
    REPORT_ID: "Report ID",
    TIMES_DELIVERED: "Times Delivered",
    TIMES_OPENED: "Times Opened",
    USAGE_RATE: "Usage Rate",
    NOT_DOWNLOADED: "Not Downloaded",
    NOT_SHARED: "Not Shared",
    GENERATION_IN_PROGRESS: "Generation In Progress",
    PARTIALLY_DOWNLOADED: "Partially Downloaded",
    SCHEDULED_REPORT_LOG: "Scheduled Report Log",
    DATE_GENERATED: "Date Generated",
    OPENED: "Opened",
    DATE_CREATED: "Date Created",
    NEW_REPORT: "New Report",
    NEW_REPORT_CREATE: "Create",
    REPORT_BUTTON_EDIT: "Edit",
    ABOUT: "About",
    VIEWED: "Viewed",
    TREND: "Trend",
    REPORT_BUTTON_EDIT_REPORT: "Edit Report",
    NOT_QUITE_WHAT_YOU_NEEDED: "Not quite what you needed?",
    WANT_A_COPY_OF_RESULTS: "Want a copy of these results?",
    REPORT_BUTTON_DONE: "Done",
    REPORT_AREAS: "{areas} areas",
    REPORT_EMPLOYEES: "{employees} employees",
    REPORT_FROM: "From",
    REPORT_TO: "To",
    UNASSIGNED: "Unassigned",
    REPORT_SECTION_OPTIONS: "Areas, Filters & Columns",
    REPORT_SECTION_OPTIONS_AREAS: "Areas",
    REPORT_SECTION_OPTIONS_FILTERS: "Filters",
    REPORT_SECTION_OPTIONS_COLUMNS: "Columns",
    REPORT_SECTION_OVERVIEW: "View Charts",
    TOP_EMPLOYEES: "Top Employees",
    HIGHLIGHTS: "Highlights",
    REPORT_SECTION_OVERVIEW_TOTAL_TREND: "Total Trend",
    REPORT_SECTION_OVERVIEW_AXIS_ABSENCES: "Absences",
    REPORT_SECTION_REPORT_DETAILS: "Report Details",
    REPORT_EXPORT_ALL: "Export All",
    REPORT_TOTAL: "Total",
    REPORT_ALL: "All",
    REPORT_RESULT: "Result",
    CHARTS: "Charts",
    MEASURE: "Measure",
    STANDART_REPORTS: "Standard Reports",
    FIRSTCARE_REPORTS_DESCRIPTION:
      "The below reports are pre-built to provide quick access to useful information at the click of a button. Give it a try and if you like what you see, consider editing and saving the report for future use.",
    MY_REPORTS: "My Reports",
    MY_SAVED_REPORTS_DESCRIPTION:
      "Any reports you create will be shown here. These are your personal reports and you are free to edit, copy, rename and delete them whenever you wish.",
    FEELING_CREATIVE: "Feeling Creative?",
    VIEW_TUTORIAL: "View Tutorial",
    NEED_SOME_HELP: "Need some help?",
    REPORTS: "Reports",
    RTW_DETAILS: "RTW Details",
    RTW_TO_INTERVIEWS: "Return to Work Interviews",
    VIEW_COMPLIANCE: "View Compliance",
    LOOKING_FOR_RTW_COMPLIANCE: "Looking for RTW Compliance Trends?",
    CREATED_AT: "Created At",
    VIEW_REPORT: "View Report",
    VIEW_CHARTS: "View Charts",
    TOTAL: "Total",
    TOTAL_OVER_12_MONTHS: "Total Over 12 Months",
    AVG_DAYS_TO_COMPLETE: "Avg Days To Complete",
    PENDING: "Pending",
    ALERT_TYPE: "Alert Type",
    VIEW_TRENDS: "View Trends",
    WANT_TO_SEE_YOUR_ABSENCE_RATES: "Want to see your absence rates?",
    NEED_TO_CONTACT_EMPLOYEE_NAME: "Need to Contact {name}?",
    ABSENCE_HISTORY_CONTACT_EMPLOYEE_TEXT_1: "You can call them on ",
    ABSENCE_HISTORY_CONTACT_EMPLOYEE_TEXT_2:
      " to discuss their absence history and any related actions, issues or meetings.",
    ABSENCE_HISTORY_CONTACT_EMPLOYEE_NO_PHONE_TEXT:
      "Unfortunately, we do not yet have a personal phone number that can be shared for this employee.",
    YESTERDAY: "Yesterday",
    LAST_7_DAYS: "Last 7 Days",
    LAST_14_DAYS: "Last 14 Days",
    LAST_30_DAYS: "Last 30 Days",
    LAST_90_DAYS: "Last 90 Days",
    LAST_MONTH: "Previous Calendar Month",
    LAST_12_MONTHS: "Previous 12 Calendar Months",
    DATE_RANGE_TOOLTIP:
      "Custom allows you to choose your own dates. All other options let you select a defined time period which is ideal for reports you want to run on a regular basis or a set schedule. Note that today is included in the Last 7 Days, Last 30 Days and Last 90 Days options.",

    // under construction banner
    UNDER_CONSTRUCTION:
      "This report is still under construction and we will let you know once it is available.  If you need any information in the meantime, please contact our Customer Service team.",

    // report filters
    REPORT_FILTER_LIST_TYPE: "Focus List Type",
    REPORT_FILTER_ABSENCE_TYPE: "Absence Type",
    REPORT_FILTER_STAFF_GROUP: "Staff Group",
    REPORT_FILTER_ABSENCE_REASON: "Absence Reason",
    REPORT_FILTER_WORK_RELATED_ONLY: "Work Related Only",
    REPORT_FILTER_QTY: "Quantity",
    REPORT_FILTER_TREND_TYPE: "Trend Type",
    REPORT_FILTER_LENGTH_TYPE: "Length Type",
    REPORT_FILTER_PERIOD_TYPE: "Period Type",
    REPORT_FILTER_DATE_RANGE: "Date Range",
    REPORT_FILTER_ADJUSTMENT_APPLIED: "Underreporting Adjustment Applied",
    REPORT_FILTER_COMPLIANCE_TYPE: "Compliance Types",
    REPORT_FILTER_MANAGER_AGE_GROUPS: "Manager Age Groups",
    GENDER: "Gender",
    REPORT_FILTER_SLA_DESCRIPTION: "SLA Description",
    REPORT_FILTER_REASON_LEVEL: "Reason Level",
    REPORT_FILTER_CLASSIFICATION: "Classification Type",
    REPORT_FILTER_ABSENCE_LENGTH: "Absence Length",
    REPORT_FILTER_HIERARCHY_LEVEL: "Hierarchy Level",
    EXCLUDED_REASONS: "Excluded Reasons",
    REPORT_FILTER_DEMOGRAPHIC_TREND_TYPE: "Demographic Trend Type",
    REPORT_FILTER_REASON_TREND_TYPE: "Reason Trend Type",

    // report columns
    RANK: "Rank",
    REPORT_COLUMN_EMPLOYEE: "Employee Ref",
    FIRST_NAME: "First Name",
    LAST_NAME: "Surname",
    DEPARTMENT: "Department",
    STAFF_TOTAL: "Staff Total",
    STAFF_DLPE: "Staff DLPE",
    RTWS_COMPLETED: "RTWs Completed",
    REPORT_COLUMN_DATE_REGISTERED: "Date Registered",
    REPORT_COLUMN_ACCOUNT_TYPE: "Account Type",
    REPORT_COLUMN_TOTAL_LOST: "Total Days Lost",
    TOTAL_ABSENCES_SPELLS: "Total Absence Spells",
    TOTAL_ABSENCES_REPORTED: "Total Absences Reported",
    TOTAL_ALERTS: "Total Alerts",
    REPORT_COLUMN_MOST_REASON: "Most Common Reason",
    DAYS_MOST_COMMON_REASON: "Most Common Reason (Days)",
    SPELLS_MOST_COMMON_REASON: "Most Common Reason (Spells)",
    REPORT_COLUMN_EMPLOYMENT_START: "Employment Start",
    TOTAL_REFERRALS: "Total Referrals",
    MONITORING_LEVEL: "Monitoring Level",
    REPORT_COLUMN_BRADFORD_SCORE: "Bradford Score",
    REPORT_COLUMN_GENDER: "Gender",
    REPORT_COLUMN_AGE_GROUP: "Age Group",
    DISCLOSURE_RATE: "Disclosure Rate",
    DISABILITY: "Disability",
    REPORT_COLUMN_ABSENCE_MONITORING_LEVEL: "Absence Monitoring Level",
    ABSENCE_RATE: "Absence Rate",
    REPORT_COLUMN_TIME_LOST_PER_EMPLOYEE: "Days Lost Per Employee",
    TOTAL_DAYS_LOST: "Total Days Lost",
    RTW_COMPLIANCE: "RTW Compliance",
    MOST_COMMON_LATE_REASON: "Most Common Late Reason",
    REPORT_COLUMN_REFERRAL_COMPLIANCE: "Referral Compliance %",
    REPORT_COLUMN_MONITORING_COMPLIANCE: "Monitoring Compliance %",
    DEPARTMENT_REFERENCE_NUMBER: "Department Ref",
    REPORT_COLUMN_MANAGER_NAMES: "Manager Names",
    REPORT_COLUMN_TOTAL_LOGINS: "Total Logins",
    LAST_LOGIN: "Last Login",
    REPORT_COLUMN_DAYS_LOST_BY_STAFF: "Staff Days Lost",
    REPORT_COLUMN_MANAGER: "Manager",
    REPORT_COLUMN_ABSENCE_AVERAGE: "Average Absence Length",
    REPORT_COLUMN_RTW_3: "RTW Compliance % in Last 3 Months",
    REPORT_COLUMN_RTW_12: "RTW Compliance % in Last 12 Months",
    REPORT_COLUMN_ABSENCE_START: "Absence Start",
    REPORT_COLUMN_ABSENCE_TYPE: "Absence Type",
    REPORT_COLUMN_RTW_AT: "RTW Date",
    REPORT_COLUMN_RTW_SENT_AT: "Date RTW Sent",
    REPORT_COLUMN_RTW_DUE_DATE: "Date RTW Due",
    DATE_RTW_DUE: "Date RTW Due",
    REPORT_COLUMN_RTW_COMPLIANT: "Compliant ?",
    REPORT_COLUMN_DATE_INTERVIEW_COMPLETED: "Date Interview Completed",
    REPORT_COLUMN_INTERVIEW_COMPLETED_BY: "Interview Completed By",
    REPORT_COLUMN_CURRENT_LEVEL: "Current Level",
    REPORT_COLUMN_EFFECTIVE_FROM: "Effective From",
    REPORT_COLUMN_EFFECTIVE_TO: "Effective To",
    REPORT_COLUMN_DECISION_BY: "Decision Made By",
    REPORT_COLUMN_DATE_NEXT_REVIEW: "Date of Next Review",
    REPORT_COLUMN_OUTSTANDING_ALERTS: "Outstanding Alerts",
    REPORT_COLUMN_REFERRAL_ID: "Referral Id",
    REPORT_COLUMN_DATE_TRIGGERED: "Date Triggered",
    REPORT_COLUMN_REFERRAL_REASON: "Referral Reason",
    REPORT_COLUMN_WELLBEING_SUPPLIER: "Weelbeing Supplier",
    REPORT_COLUMN_DECIDED_AT: "Decision Date",
    REPORT_COLUMN_MANAGER_NAME: "Manager Name",
    REPORT_COLUMN_DECISION: "Decision",
    REPORT_COLUMN_ALERT_TRIGGERED: "Alert Triggered",
    REPORT_COLUMN_ABSENCE_DATES: "Absence Dates",
    REPORT_COLUMN_STAFF_GROUP: "Staff Group",
    DAYS_LOST_PER_EMPLOYEE: "Total DLPE",
    HIGHEST_REASON: "Highest Reason {num}",
    INTERVIEW_STATUS: "Interview Status",
    ABSENCE_STARTS_AT: "Absence Start Date",
    RTW_AT: "RTW Date",
    COMPLETION_DATE: "Completion Date",
    MANAGER_EMAILS: "Manager Emails",
    HAS_DISABILITY: "Has Disability",
    EMPLOYEE_POSITION: "Position",
    ABSENCE_RTW_AT: "Absence RTW Date",
    DAYS_LOST_BY_STAFF: "Staff Days Lost",
    EMPLOYEE_ABSENCE_BREAKDOWN: "Employee Absence Breakdown",
    EMPLOYEE_ABSENCE_BREAKDOWN_TABLE_LABEL: "Employee Split: {name}",
    LEGAL: "Legal",
    PERIOD_START: "Period Start",
    PERIOD_END: "Period End",
    NO_RESULTS_TEXT: "No results for the specified criteria",
    SEE_MORE: "See more...",

    // landing
    FOCUS_LIST_DESCRIPTION:
      "Access a series of detailed focus lists that will enable you to zero in on the key managers, employees and departments with the high amount of  absence. Here is also the place to visit if you would like to see the best and worst performing areas when it comes to task compliance.",
    FOCUS_LIST_ACTION_TEXT: "View Focus Lists",
    REPORTS_DESCRIPTION:
      "Access detailed reports that reflect your chosen search criteria. You can run reports on absences, employees, managers, return to work interviews, alerts, absence monitoring levels and wellbeing referrals. It is the ideal place to go if you have a specific topic in mind that you wish to explore.",
    REPORTS_ACTION_TEXT: "Search for an Employee",
    TOOLS_DESCRIPTION:
      "Access a range of absence management tools, including a real-time dashboard, your task queue and your recent notifications.",
    TOOLS_ACTION_TEXT: "Go to Dashboard",
    TRAINING_DESCRIPTION:
      "Access a range of tools designed to help you understand how to get the best out of GoodShapeCentral!. Glossaries, guides and FAQ’s are all available to help you guide you in your use of the system.",
    TRAINING_ACTION_TEXT: "Visit Training Centre",
    TRENDS_DESCRIPTION:
      "Access a wide range of trends, including absence rates, absence reasons, RTW Interview compliance. Trends can be fund for any absence type and for the period of your choice.",
    TRENDS_ACTION_TEXT: "Analyse Absence Trends",
    PLACE_TO_START_LABEL: "Where is a good place to start?",
    GUIDANCE_LABEL: "Want some guidance?",
    GUIDANCE_GO: "Open Training Centre",
    SEE_ALL_CLIENTS: "See All Clients",
    EMPLOYEE_LANDING_DESCRIPTION:
      "Here you will be able to view historical absences, absence statistics, notifications details and any actions that are outstanding to be completed for a selected employee.",
    EMPLOYEE_LANDING_ACTION_TEXT: "Search for an Employee",
    MANAGERS_LANDING_DESCRIPTION:
      "Here you will be able to view portal usage, task compliance and employee and notification setup for a selected manager.",
    MANAGERS_LANDING_ACTION_TEXT: "Search for a Manager",
    GO_TO_REPORTS: "Go to Reports",
    WANT_TO_SEE_WHICH_EMPLOYEES_HAVE_THE_MOST_ABSENCE:
      "Want to see which employees have the most absence?",

    // Dashboard Overview
    DASHBOARD_OVERVIEW_DASHBOARD: "Dashboard",
    DASHBOARD_OVERVIEW_TODAY: "Today's Headlines",
    CORONAVIRUS_HEADLINES: "Coronavirus Headlines",
    TOP_DEPARTMENT: "Department with most COVID Absences To Date:",
    DASHBOARD_OVERVIEW_NOTIFICATION_REVIEWS: "Notification Reviews",
    DASHBOARD_OVERVIEW_MANAGE: "Manage",
    DASHBOARD_OVERVIEW_STATISTICS: "Statistics",
    DASHBOARD_OVERVIEW_CONFIGURE: "Configure",
    DASHBOARD_OVERVIEW_LABEL: "Label",
    DASHBOARD_OVERVIEW_VALUE: "Value",
    TODAYS_TOP_REASON: "Today's Top Reason",
    NEW_ALERTS: "New alerts",
    RECENT_NOTIFICATIONS: "Recent Notifications",
    OUTSTANDING_TASKS: "Outstanding Tasks",
    VIEW_THE_LATEST_ACTIVITIES: "View the Latest Activities",
    ACTIVITIES: "Activities",
    MY_RTW_TASK_QUEUE: "My RTW & Task Queue",
    ACTIVITY_FEED: "Activity Feed",
    TODO_LIST: "To Do List",
    DATA_FORECASTS: "Data Forecasts",
    FORECAST: "Forecast",
    ADMIN_CONSOLE: "Admin Console",
    DATA_UPLOAD: "Data Upload",
    DATA_EXCHANGE: "Data Exchange",
    HIERARCHY_TREE: "Hierarchy Tree",
    SCRIPTS: "Scripts",
    HIERARCHY_CONTACTS: "Hierarchy Contacts",
    ABSENCE_ALERTS: "Absence Alerts",
    REPORT_PARAMETERS: "Report Parameters",
    DEPARTMENT_FOCUS_LIST: "Department Focus List",
    DEPARTMENT_FOCUS_LIST_WITH_SUFFIX: "Department Focus List: {name}",
    BACK_TO_TODAYS_HEADLINES: "Back to Today's Headlines",
    ACTIVITY: "Activity",
    WHEN: "When",
    UPDATES_IN_LAST_24_HOURS: "Updates in the Last 24 Hours",
    ACTIVITIES_IN_LAST_24_HOURS: "Activities in Last 24 Hours",
    CORONAVIRUS_NEWS: "Coronavirus News",
    TASK_QUEUE: "Task Queue",
    TASKS: "Tasks",
    TRENDS: "Trends",
    UNFINISHED_TASKS_COUNT: "You have {tasksCnt} unfinished tasks",
    YOUR_TASKS_QUEUE: "Your Task Queue",
    NOTIFICATION_INBOX: "Notification Inbox",
    ABSENCE_INDEX_BENCHMARKING: "Absence Index Benchmarking",
    DOWNLOAD_FAQ: "Download FAQ",
    TOTAL_BENCHMARKS: "Total Benchmarks",
    BENCHMARKS: "Benchmarks",
    BENCHMARKING_INDEX: "Benchmarking Index",
    BETTER_THAN_NATIONAL_AVERAGE: "Better Than Average",
    EQUAL_TO_NATIONAL_AVERAGE: "Equal to Average",
    BEHIND_NATIONAL_AVERAGE: "Behind the Average",
    YOUR_STAFF: "Your Staff",
    ORGANISATION_DLPE: "Organisation DLPE",
    PERCENT_V_ORGANISATION: "% v Organisation",
    INDUSTRY_DLPE: "Industry DLPE",
    PERCENT_V_INDUSTRY: "% v Industry",
    NATIONAL_DLPE: "National DLPE",
    PERCENT_V_NATIONAL: "% v National",
    LAST_N_DAYS: "Last {count} Days",
    STAFF_CURRENTLY_ABSENCE: "Staff Currently Absence",
    VIEW_LIST: "View List",
    VIEW_TREND: "View Trend",
    PERCENT_OF_ABSENT: "% of Staff Absent",
    RTW_AND_OUTSTANDING: "RTWs & Tasks To Do",
    FORECAST_LONG_TERM_ABSENCE: "1+ Long Term Absence",
    FORECAST_MEDIUM_TERM_ABSENCE: "1+ Medium Term Absence",
    FORECAST_SHORT_TERM_ABSENCE: "1+ Short Term Absence",
    FORECAST_FREQUENT_ABSENCE: "4+ Any Absence",
    LEAVING_ORGANISATION: "Leaving Organisation",
    DASHBOARD_HELP_INTRODUCTION:
      "This page provides a real-time overview of absence among the employee population you have been granted access to. Its purpose is to provide an immediate indication of today’s absence levels, how they compare to recent trends, the most common health issues, and the departments most impacted.",
    DASHBOARD_INSTRUCTIONS: "Dashborad Instructions",
    STAFF_ABSENT_PERCENTAGE: "% Staff Absent",
    DAY_TREND: "21 Day Trend",
    DASHBOARD_OPEN_ABSENCES_DESCRIPTION:
      "This is the number of employees who have a current open absence. This total includes absences that are overdue, meaning the employee was expected to return to work previously but has not correctly updated or closed their absence.",
    DASHBOARD_STAFF_ABSENT_DESCRIPTION:
      "This is the % of your active employees that currently have an open absence. For example, if you have 100 employees, and 10 of them have an open absence, then the % Staff Absent will show as 10%.",
    DASHBOARD_OUTSTANDING_TASKS_DESCRIPTION:
      "This is the total number of outstanding tasks that need to be completed, such as Return to Work Interviews. Clicking this button will take you to the Task Queue.",
    DASHBOARD_RECENT_ALERTS_DESCRIPTION:
      "This is the total number of absence policy alerts that have been triggered by your employees in the last 24 hours.",
    DASHBOARD_RECENT_NOTIFICATIONS_DESCRIPTION:
      "This is the total number of absence notifications that you have been sent in the last 24 hours. Clicking the button will take you to the list of notifications.",
    DASHBOARD_ST_ABSENCES_DESCRIPTION: `This is a count of how many employees were absent on a given day due to a {st} absence. To be counted as absent, the day has to be a "Working Day" in the employee's shift pattern.`,
    DASHBOARD_LT_ABSENCES_DESCRIPTION: `This is a count of how many employees were absent on a given day due to a {lt} absence. To be counted as absent, the day has to be a "Working Day" in the employee's shift pattern. The definition of a Long Term absence is defined by your organisation and is viewable by clicking on the "?" icon in the charts title.`,
    DASHBOARD_TOTAL_ST_LT_ABSENCES_DESCRIPTION:
      "This is the total number of Open ST Absences and Open LT Absences combined.",
    DASHBOARD_EMPLOYEES_ABSENCT_DESCRIPTION:
      "This is the Total Absences as a percentage of the total active employees on each day. For example, if there were 5 total absences out of a 100 employee headcount, the % absence rate would be 5%.",
    DASHBOARD_DEPARTMENT_DESCRIPTION:
      "This is the name of the department, as identified in your hierarchy structure. The table is ordered so that the department with the highest number of current open absences appears at the top.",
    DEPARTMENT_TOTAL_ABSENCES_DESCRIPTION:
      "This is a count of how many employees have an open absence in each department.",
    DEPARTMENT_ST_ABSENCES_DESCRIPTION:
      "This is a count of how many employees have an open {st} absence in each department.",
    DEPARTMENT_LT_ABSENCES_DESCRIPTION:
      "This is a count of how many employees have an open {lt} absence in each department.",
    DEPARTMENT_EMPLOYEES_ABSENCE_DESCRIPTION:
      "This shows the % of active employees absent in each department. For example, if a department has an active Headcount of 22, of which 13 employees have an open absence, that means 59.1% of employees are absent.",
    DEPARTMENT_RTW_DESCRIPTION:
      "This shows how many incomplete RTW Interviews exist for previously closed absences within the department.",
    OPEN_ABSENCES_BY_REASON: "Open Absences by  Reason",
    DASHBOARD_ABSENCE_REASON_DESCRIPTION:
      "This is the name of the absence reason classification. The table is ordered so that the absence reason that accounts for the highest number of current open absences appears at the top.",
    REASON_TOTAL_ABSENCES_DESCRIPTION:
      "This is a count of how many employees have an open absence due to the stated reason.",
    REASON_ST_ABSENCES_DESCRIPTION:
      "This is a count of how many employees have an open {st} absence due to the stated reason.",
    REASON_LT_ABSENCES_DESCRIPTION:
      "This is a count of how many employees have an open {lt} absence due to the stated reason.",
    REASON_TOTAL_ABSENCES_PERCENTAGE_DESCRIPTION:
      "This shows what percentage of the total open absences each absence reason accounts for.",
    REASON_ESTIMATED_AVERAGE_DESCRIPTION:
      "This column shows the average duration of the currently open absences assigned to each reason. It includes all days lost up to the current estimated return to work date for each absence.",
    REASON_ESTIMATED_TOTAL_DAYS_DESCRIPTION:
      "This is an estimate of the total working days that will be lost by the current open absences for each reason. It is calculated by adding up the working days expected to be missed by each employee up to their presently expected return to work date.",

    // Absence now
    DATE: "Date",
    TOTAL_ABSENCES_NUMBER: "Total Absences",
    EMPL_ABS_PERCENTAGE: "% Employees Absent",
    WEEKDAYS: "Weekdays",
    DEPARTMENT_NAME: "Department Name",
    HEADCOUNT: "Headcount",
    HOW_ARE_HEADCOUNTS_CALCULATED: "How are Headcounts Calculated?",
    PENDING_TASKS: "Pending Tasks",
    ABSENCE_NOW: "Absence Now",
    TREND_ACTIVITY: "Absent Staff: 21 Day Trend",
    ABSENCE_FOR_PREV_AND_NEXT_TEN_DAYS:
      "The trend below shows the number of absent employees per day for the last 3 weeks, split by absence length. For the purposes of this report Long Term Absence is defined as: {longTermDefinitionDays} {longTermDefinitionType} Days.",
    DAY: "Day",
    SHORT_TERM_ABSENCE: "Short Term Absence",
    EMPLOYEES_ABSENT: "Employees Absent",
    DEPARTMENT_OVERVIEW: "Department Overview",
    OPEN_ABSENCES_BY_DEPARTMENT: "Open Absences by Department",
    HIERARCHY_BREAKDOWN: "Hierarchy Breakdown",
    TOTAL_OPEN_ABSENCES: "Total Open Absences",
    OPEN_ST_ABSENCES: "Open ST Absences",
    OPEN_LT_ABSENCES: "Open LT Absences",
    PERCENTAGE_EMPLOYEE_ABSENT: "% Employees Absent",
    STAFF_AVAILABLE_TODAY: "Staff Available Today",
    STAFF_AVAILABLE_TOMORROW: "Staff Available Tomorrow",
    PERCENT_EMPL_ABSENT:
      "The report below shows which departments have the highest % of their employees absent today. It is these departments that may struggle to cope with resource shortages and meet minimum staffing levels.",
    DEPARTMENT: "Department",

    // Absence Details
    ALL_OPEN_ABSENCES: "All Open Absences",
    AREAS: "Areas",
    SLIDES: "Slides",
    INCLUDE: "Include",
    EXCLUDE: "Exclude",
    AREAS_FILTERS_COLUMNS: "Areas, Filters & Columns",
    AREAS_FILTERS: "Areas, Filters",
    DONE: "Done",
    FILTERS: "Filters",
    COLUMNS: "Columns",
    SHOW_HIDE_COLUMNS: "Show/Hide Columns",
    OVERVIEW: "Overview",
    MOST_ABSENCES_BY_DEPARTMENT: "Most Absences by Department",
    CORONAVIRUS_ABSENCES_PER_DAY_LAST_30_DAYS: "Coronavirus Absences per Day: Last 30 Days",
    CORONAVIRUS_DEPARTMENT_HEAT_MAP_LAST_30_DAYS: "Coronavirus Department Heat Map: Last 30 Days",
    CORONAVIRUS_ABSENCES_BY_AGE_GROUP: "Coronavirus Absences by Age Group",
    CORONAVIRUS_RELATED_ABSENCES_BY_AGE_GROUP: "Coronavirus Related Absences by Age Group",
    CORONAVIRUS_COVID19_CARE_OF_A_DEPENDANT: "Care of Dependent Absences to Date:",
    CORONAVIRUS_COVID19_CONFIRMED: "Confirmed COVID Absences To Date:",
    CORONAVIRUS_COVID19_SELF_QUARANTINED: "Self-Quarantined Absences To Date:",
    CORONAVIRUS_COVID19_SUSPECTED: "Suspected COVID Absences To Date:",
    CORONAVIRUS_COVID19_SUSPECTED_WFH: "Coronavirus:  COVID19 Suspected WFH",
    COVID_19: "COVID-19",
    COVID_19_TRACKER: "COVID-19 Tracker",
    COVID_19_CONFIRMED: "COVID-19 Confirmed",
    COVID_19_SUSPECTED: "COVID-19 Suspected",
    CASES: "Cases",
    CASE: "Case",
    AVERAGE_DAYS_LOST: "Average Length (Days Lost)",
    MALE: "Male",
    MALE_ABSENCES: "Male COVID Absences to Date:",
    FEMALE: "Female",
    FEMALE_ABSENCES: "Female COVID Absences to Date:",
    PERCENTAGE_ABSENCES_BY_LENGTH: "% Absences By Length",
    WORKING_DAYS_IN_PERIOD: "Working Days In Period",
    HOURS_DAYS_IN_PERIOD: "Hours Days In Period",
    CALENDAR_DAYS_IN_PERIOD: "Calendar Days In Period",
    PERCENTAGE_ABSENCES_BY_STAFF_GROUP: "% Absences By Staff Group",
    EXPORT_ALL: "Export All",
    EXPORT_REPORT: "Export Report",
    EMPLOYEE_REF: "Employee Ref.",
    EMPLOYEE_REF_TOOLTIP:
      "This is used as a unique identifier for each of your employees. Clicking on the Employee Ref will open the employees record in a new tab.",
    END: "End",
    DAYS: "Days",
    DURATION_TYPE: "Duration Type",
    DURATION_RANGE: "Duration Range",
    VIEW_SHIFT_PATTERN: "View Shift Pattern",
    VIEW_ADDITIONAL_DETAILS: "View Additional Details",
    VIEW_NOTIFICATIONS: "View Notifications",
    VIEW_RTW_INTERVIEW_FORM: "View RTW Interview Form",
    VIEW_NOTES: "View Notes",
    VIEW_DOCUMENTS: "View Documents",
    OPEN_ONLY: "Open Only",
    STRESS_ANOTHER_REASON: "Stress, Another Reason",
    MOCKED_AGES: "21-30, 31-40",
    MOCKED_ABSENCES_RANGE: "> 2 days",
    GROUPS: "Groups",
    CUSTOM: "Custom",
    SHORT_TERM: "Short Term",
    LONG_TERM: "Long Term",
    MEDIUM_TERM: "Medium Term",
    FREQUENT_ABSENCES: "Frequent Absences",
    STAFF_TURNOVER: "Staff Turnover",
    ABSENCES_GREATER_THAN: "Absences Greater Than",
    AGES: "Ages",
    ABSENCE_STATUS: "Absence Status",
    INCLUDE_LEAVERS: "Include Leavers",
    EMPLOYEES_WITH_DISABILITY: "Employees with Disability",
    TYPES_OF_UPDATES: "Types of Updates",
    DAYS_TILL_RETURN: "Days Till Return",
    SCHEDULED_TO_WORK_TODAY: "Scheduled to work today?",
    SPELLS_LAST_12_MONTH: "Spells in last 12 months",
    DAYS_LOST_LAST_12_MONTH: "Days lost in last 12 months",
    NON_MEDICAL_STATUS: "Non-Medical Authorisation Status",
    READY_TO_CONTINUE: "Ready to continue?",
    NEXT: "Next",
    NEXT_COLUMNS: "Next: Columns",
    NEXT_SLIDES: "Next: Choose Slides",
    SET_FILTERS: "Set Filters",
    SELECT_COLUMNS: "Select Columns",
    GENERATE_REPORT: "Generate Report",
    RUN_REPORT_DEFAULT: "Run Report",
    SAVE_REPORT: "Save Report",
    SAVE_AS_REPORT: "Save As",
    TWENTY_OR_UNDER: "20 or under",
    TWENTY_ONE_TO_TWENTY_FIVE: "21 – 25",
    TWENTY_SIX_TO_THIRTY: "26 – 30",
    THIRTY_ONE_TO_THIRTY_FIVE: "31 – 35",
    THIRTY_SIX_TO_FORTY: "36 – 40",
    FORTY_ONE_TO_FORTY_FIVE: "41 – 45",
    FORTY_SIX_TO_FIFTY: "46 – 50",
    FIFTY_ONE_TO_FIFTY_FIVE: "51 – 55",
    FIFTY_SIX_TO_SIXTY: "56 – 60",
    SIXTY_ONE_TO_SIXTY_FIVE: "61 – 65",
    OVER_SIXTY_FIVE: "Over 65",
    COPY_REPORT: "Copy Report",
    DUPLICATE: "Duplicate",
    NEW_REPORT_COPY_NAME: "New Report Copy Name",
    RENAME_REPORT: "Rename Report",
    REPORT_NAME_WAS_SUCCESSFULLY_REMOVED: 'Report "{name}" was successfully removed',
    UNKNOWN: "Unknown",
    LAST_ABSENCE_DAY: "Last Absence Day",
    TOP_10_EMPLOYEES_BY_WORKING_DAYS_LOST: "Top 10 Employees by Working Days Lost",
    TOP_5_ABSENCE_REASONS_BY_WORKING_DAYS_LOST: "Top 5 Absence Reasons by Working Days Lost",
    ACTUAL_ABSENCE_RATE: "Actual Absence Rate",
    ABSENCE_RATE_LAST_12_MONTHS: "Absence Rate: Last 12 Months",
    N_MINUTES_AGO: "< {mins} min ago",
    N_HOURS_AGO: "< {hours} hour ago",
    SETUP_REPORT: "Setup Report",
    REPORT_ENABLED: "Report Enabled",
    REPORT_DISABLED: "Report Disabled",

    //Tasks overview
    TOTAL_OUTSTANDING_TASKS: "Total Outstanding Tasks",
    OUTSTANDING_RTW_INTERVIEWS: "Outstanding RTW Interviews",

    //Absence Monitoring Details
    REVIEW_MEETING_STATUS: "Review Meeting Status",
    EMPLOYEES_PER_MONITORING_LEVEL: "Employees Per Monitoring Level",
    STATUS_OF_REVIEW_MEETINGS: "Status of Review Meetings",
    UPDATED_ABSENCES: "Updated Absences",
    UPDATED_ABSENCES_TOOLTIP:
      "This is the number of absences that have been updated in the last 24 hours. An update is when an absence has its reason changed, or a new Return to Work date set.",
    CLOSED_ABSENCES: "Closed Absences",
    MANAGER_UPLOADS: "Manager Uploads",
    EMPLOYEE_CURRENT_LEVEL: "Employee's Current Level",
    NEW_UPDATED_ABSENCES: "New & Updated Absences",
    ALERTS_REVIEWS: "Alerts & Reviews",
    EMPLOYEE_MONITORING_HISTORY: "{employeeName}: History",
    ABSENCE_REVIEW_HISTORY: "Absence Review History",
    MISSING_ABSENCE_REVIEW_HISTORY:
      "This employee does not have any previous absence monitoring history.",
    NOT_RECORDER: "Not Recorded",

    //RTW Details
    LATE_RTW_REASONS: "Late RTW Reasons",
    OUTSTANDING_RTWS: "Outstanding RTW's",
    RTWS_COMPLETED_ON_TIME: "RTW's Completed on Time",

    // Referral Details
    REFERRAL_DETAILS: "Referral Details",
    RTW_REFERRAL_DETAILS: "Return To Work",
    FIT_DATE_AND_TIME: "Fit Date and Time",
    RTW_DATE_AND_TIME: "RTW Date and Time",
    TREATMENT_OUTCOMES: "Treatment/Outcomes",
    TREATMENT_OUTCOME: "Treatment/Outcome",
    TREATMENT_OUTCOME_HISTORY: "Treatment/Outcome History",
    DATE_TIME: "Date/Time",
    SELECTED_ACTION: "Selected Action",
    ADDITIONAL_COMMENTS: "Additional Comments",
    REFERRAL_STATUS: "Referral Status",
    REFERRAL_STATUS_MODAL_MESSAGE:
      "This referral is currently active. If your work on the referral is complete and you wish to update its status to closed, please select a status outcome below",
    REFERRAL_FORM: "Referral Form",
    BREAKDOWN_OF_REFERRAL: "Breakdown of Referral Outcomes",
    TOTAL_REFERRALS_TRIGGERED: "Total Referrals Triggered by Referral Criteria",
    REFERRAL_DETAILS_BY_ID: "Referral Details #{id}",

    // Alert Details
    ALERT_TYPES: "Alert Types",
    ALERT_DETAILS: "Alert Details",
    TOP_FIVE_POSITIONS_TRIGGERED_ALERTS: "Top 5 Positions Triggered Alerts",
    POSITIONS_TRIGGERED_MOST_ALERTS: "Positions That Triggered the Most Alerts",
    ALERTS_TRIGGERED_BY_STAFF_GROUP_BY_MONTH: "Alerts Triggered by Staff Group by month",
    TOP_FIVE_ALERTS_TRIGGERED: "Top 5 Alerts Triggered",

    // Employee Tooltip
    EMPL_TOOLTIP_EMPLOYEE_REF: "Employee Ref.",
    EMPL_TOOLTIP_JOB_ROLES: "Job Roles",
    EMPL_TOOLTIP_START_DATE: "Start Date",
    EMPL_TOOLTIP_DATE_OF_BIRTH: "Date of Birth",
    EMPL_TOOLTIP_ABSENCES: "Absences",
    EMPL_TOOLTIP_STATUS: "Status",

    // Focus List
    FOCUS_LIST_TITLE: "Focus Lists",
    FOCUS_LIST_SECTION_HOME: "Home",
    FOCUS_LIST_SECTION_EMPLOYEE_FOCUS_LIST: "Employee Focus List",
    FOCUS_LIST_SECTION_DEPARTMENT_FOCUS_LIST: "Department Focus List",
    FOCUS_LIST_OVERVIEW_DESCRIPTION:
      "Here you can access a series of lists that will enable you to focus on the key employees that meet a chosen absence criteria, such as the having the highest number of absence spells in a given period..",
    FOCUS_LIST_OVERVIEW_HOW_LABEL: "How do reports work?",
    FOCUS_LIST_OVERVIEW_HOW_DESCRIPTION_1:
      "Each focus list allows you to specify a criteria for the list you wish to build. You can also choose how long the list is (such as only showing the top 50 employees) and the order of the list (such as the most days lost). The reports will only include data for employees or departments that you are authorised to see and there are 3 ways that you can approach running each focus list:",
    FOCUS_LIST_OVERVIEW_HOW_DESCRIPTION_OPT_1: "Run a GoodShape Report.",
    FOCUS_LIST_OVERVIEW_HOW_DESCRIPTION_OPT_2: "Run one of your own previously saved reports.",
    FOCUS_LIST_OVERVIEW_HOW_DESCRIPTION_OPT_3: "Creare a brand new report from scratch",
    FOCUS_LIST_OVERVIEW_HOW_DESCRIPTION_3:
      "Whichever path you choose, you will see detailed absence information that you can review on screen or export to Excel.",
    FOCUS_LIST_OVERVIEW_WHERE_DESCRIPTION_1:
      "The Employee Focus List page will enable you to see the employees that have had the highest amount of absence in your area. For each employee you can see their total time lost, absence spells and alerts triggered.",
    FOCUS_LIST_OVERVIEW_WHERE_DESCRIPTION_2:
      "This is an ideal way to see which employees you should focus on when it comes to tackling high absence.",
    FOCUS_LIST_OVERVIEW_GUIDANCE_DESCRIPTION:
      "Remember that you can revisit the Reports section of the Training Centre at any time to familiarise yourself with how they work and how they can help.",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OPTIONS_AREAS: "Areas",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OPTIONS_AREAS_STEP_1: "1/3 Areas",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OPTIONS_FILTERS: "Filters",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OPTIONS_FILTERS_STEP_2: "2/3 Filters",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OPTIONS_COLUMNS: "Columns",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OPTIONS_COLUMNS_STEP_3: "3/3 Columns",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OVERVIEW_PERCENT_OF_ABSENCE: "% of Absence",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_OVERVIEW_PERCENT_OF_EMPLOYEES: "% of Employees",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_ACTION_VIEW_SHIFT_PATTERN: "View Shift Pattern",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_ACTION_VIEW_ADDITIONAL_DETAILS:
      "View Additional Details",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_ACTION_VIEW_NOTIFICATIONS: "View Notifications",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_ACTION_VIEW_RTW: "View RTW Interview Form",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_ACTION_VIEW_NOTES: "View Notes",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_ACTION_VIEW_DOCUMENTS: "View Documents",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_NEW_LABEL: "New Employee Focus List Report",
    FOCUS_LIST_EMPLOYEE_REPORT_SECTION_REPORT_NEW_APPLY: "Apply",
    FOCUS_LIST_MANAGER_COLUMN_NAME: "Report Name",
    FOCUS_LIST_MANAGER_COLUMN_CREATED: "Date Created",
    FOCUS_LIST_MANAGER_REPORT_AREAS: "{areas} areas",
    FOCUS_LIST_MANAGER_REPORT_EMPLOYEES: "{employees} employees",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS: "Areas, Filters & Columns",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS_AREAS: "Areas",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS_AREAS_STEP_1: "1/3 Areas",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS_FILTERS: "Filters",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS_FILTERS_STEP_2: "2/3 Filters",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS_COLUMNS: "Columns",
    FOCUS_LIST_MANAGER_REPORT_SECTION_OPTIONS_COLUMNS_STEP_3: "3/3 Columns",
    FOCUS_LIST_MANAGER_REPORT_SECTION_REPORT: "View Report",
    FOCUS_LIST_MANAGER_REPORT_SECTION_REPORT_EXPORT_ALL: "Export All",
    FOCUS_LIST_MANAGER_REPORT_SECTION_REPORT_NEW_LABEL: "New Manager Focus List Report",
    FOCUS_LIST_DEPARTMENT_COLUMN_NAME: "Report Name",
    FOCUS_LIST_DEPARTMENT_COLUMN_CREATED: "Date Created",
    FOCUS_LIST_REPORT: "Focus List Report",
    USING_YOUR_DASHBOARD: "Using Your Dashboard",

    FOCUS_LIST_DEPARTMENT_REPORT_AREAS: "{areas} areas",
    FOCUS_LIST_DEPARTMENT_REPORT_EMPLOYEES: "{employees} employees",
    FOCUS_LIST_DEPARTMENT_REPORT_FROM: "From",
    FOCUS_LIST_DEPARTMENT_REPORT_TO: "To",
    FOCUS_LIST_DEPARTMENT_REPORT_BUTTON_EDIT: "Edit",
    FOCUS_LIST_DEPARTMENT_REPORT_BUTTON_DONE: "Done",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS: "Areas, Filters & Columns",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS_AREAS: "Areas",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS_AREAS_STEP_1: "1/3 Areas",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS_FILTERS: "Filters",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS_FILTERS_STEP_2: "2/3 Filters",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS_COLUMNS: "Columns",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OPTIONS_COLUMNS_STEP_3: "3/3 Columns",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_REPORT_NEW_LABEL: "New Department Focus List Report",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_OVERVIEW: "View Charts",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_REPORT: "View Report",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_REPORT_TARGET_ABSENCE_RATE:
      "Your Organizations Target Absence Rate is {rate}%",
    FOCUS_LIST_DEPARTMENT_REPORT_SECTION_REPORT_EXPORT_ALL: "Export All",
    FOCUS_LIST: "FOCUS LIST",

    // Mi Reports
    PRESENTATION_BUILDER: "Presentation Builder",
    MI_PRESENTATION: "MI Presentation",
    MI_PRESENTATIONS: "MI Presentations",
    MY_SAVED_MI_PRESENTATIONS: "My Presentations",
    DEFAULT_PRESENTATIONS: "Standart Presentations",
    PRESENTATION_NAME: "Presentation Name",
    SHARED_MI_PRESENTATIONS: "Presentations Shared With Me",
    PUBLISHED_DATE: "Date Published",
    PUBLISHED_BY: "Published By",
    DATE_VIEWED: "Date Viewed",
    MI_REPORTS: "MI Reports",
    DOWNLOAD_DATE: "Date Downloaded",
    IS_DOWNLOADED: "Downloaded?",
    PRESENTATION_LOG: "Presentation Log",
    DATE_SHARED: "Date Shared",
    SHARED_BY: "Shared By",
    SHARED_WITH: "Shared with",
    SHARE: "Share",
    SAVE_DUPLICATE_PRESENTATION: "Save As New Presentation",
    SHARE_PRESENTATION: "Share Presentation",
    STEP_SELECT_AND_SEARCH_EMPLOYEE: "Step 1: Search & Select Employee",
    NO_PRESENTATIONS_TEXT: "No Presentations To Show",
    ALREADY_SHARED: "already shared",
    PRESENTATION_ID: "Presentation ID",
    PROCEED_TO_SHARE: "Proceed to Share",
    DOWNLOAD_TOOLTIP:
      "The Download button will enable you to download MI Presentations to PowerPoint. Please note that the button will be inactive momentarily whilst the MI Presentation is generated.",
    EDIT_TOOLTIP:
      "You can edit MI Presentations configurations by selecting the Edit option. Please note that the button will be inactive momentarily whilst the MI Presentation is generated.",
    SHARE_TOOLTIP:
      "Share your own MI Presentations with key recipients directly to their GoodShape account. Please note that the button will be inactive momentarily whilst the MI Presentation is generated.",
    LOG_TOOLTIP:
      "You can access the Log for shared MI Presentations to view the date and time the recipient has downloaded the MI Presentation from their GoodShape account.",
    MI_SHARING_NOTICE: "MI Presentations Sharing Notice:",
    MI_SHARING_NOTICE_PART_ONE:
      "The security and confidentiality of employee's personal information is of paramount importance to GoodShape.",
    MI_SHARING_NOTICE_PART_TWO:
      "As such, we want to bring to your attention that, by sharing MI Presentations with other HR members that have areas of access restricted in the organisation, they will still be able to view all the information in the MI Presentations as this will not adjust to match the recipient's area of access scope.",
    MI_SAVE_PRESENTATION_DISCLAIMER:
      "Great work! Please give your report a name so that you can find it later. Once saved, your report will begin compiling and the page will update to let you know it is available to download and use.",
    SLIDE_NAME: "Slide Name",

    // Changes Awaiting
    CHANGES_AWAITING: "Changes Awaiting",
    CHANGE_NOTIFICATION_TYPE: "Change Notification Contact Type",
    ADD_NOTIFICATIONS: "Add Notification Contact(s)",
    ADD_NOTIFICATION: "Add Notification",
    FULL_NOTIFICATION: "Full",
    BASIC_NOTIFICATION: "Basic",
    DESELECT_ALL: "Deselect All",
    RECORDS_SELECTED: "records selected",
    RECORD_SELECTED: "record selected",
    MANAGER_EMPLOYEE_REF: "Manager's Employee Reference",
    MANAGER_NAME: "Manager's Name",
    DATE_REQUESTED: "Date Requested",
    EMPLOYEES_REF_NO: "Employee's Reference Number",
    EMPLOYEE_NAME: "Employee's Name",
    NEW_CONTACT_NAME: "New Contact Name",
    NEW_CONTACT_REF: "New Contact Reference",
    NOTIFICATION_TYPE: "Notification Type",
    NOTIFICATION_TYPE_CHANGE: "Notification Type Change",
    REMOVE_NOTIFICATION_CONTACTS: "Remove Notification Contact(s)",
    // Trends
    TRENDS_TITLE: "Trends",
    TRENDS_OVERVIEW_DESCRIPTION:
      "Here you can view a range of absence trends, such as absence rates, days lost per employee averages and absence reasons. This is ideal for monitoring changes in absence trends over a broad period of time.",
    TRENDS_OVERVIEW_HOW_LABEL: "How do trends work?",
    TRENDS_OVERVIEW_HOW_DESCRIPTION_1:
      "Each trend report provides you with access to a range of aggregated trends calculated over a period of time. You are able to choose your preferred trend (such as days lost), duration (such as the last 12 months) and period type (Weekly, Monthly etc.). The resulting trend will show what pattern absence has followed, in both a chart and table format.",
    TRENDS_OVERVIEW_HOW_DESCRIPTION_2:
      "The trends will only aggregate data for employees or departments that you are authorised to see and there are 3 ways that you can approach running each trend:",
    TRENDS_OVERVIEW_HOW_DESCRIPTION_OPT_1: "Run a GoodShape Report.",
    TRENDS_OVERVIEW_HOW_DESCRIPTION_OPT_2: "Run one of your own previously saved reports.",
    TRENDS_OVERVIEW_HOW_DESCRIPTION_OPT_3: "Create a brand new report from scratch.",
    TRENDS_OVERVIEW_HOW_DESCRIPTION_3:
      "Whichever path you choose, you will see detailed absence information that you can review on screen or report to Excel.",
    TRENDS_OVERVIEW_WHERE_DESCRIPTION_1:
      "The Absence Rates page will provide you with a top level summary of how much time has been lost to absence. The trend line will enable you to see if the absence is increasing or reducing and to what extend.",
    TRENDS_SECTION_EMPLOYEE_DETAILS_REPORT: "Employee Details Report",
    ABSENCE_RATE_TRENDS_REPORT: "Absence Rate Trends Report",
    TRENDS_OVERVIEW_GUIDANCE_DESCRIPTION:
      "Remember that you can revisit the Trends section of the Training Centre at any time to familliarise yourself with how they work and how they can help.",
    TRENDS_SECTION_ABSENCE_RATE: "Absence Rate Trends",
    TRENDS_ABSENCE_RATE_REPORT_LABEL: "New Absence Rate Trends Report",
    TRENDS_ABSENCE_RATE_SECTION_OPTIONS: "Areas, Filters, Group By & Comparator",
    TRENDS_ABSENCE_RATE_OPTIONS_AREAS: "Areas",
    TRENDS_ABSENCE_RATE_OPTIONS_AREAS_STEP_1: "1/4 Areas",
    TRENDS_ABSENCE_RATE_OPTIONS_FILTERS: "Filters",
    TRENDS_ABSENCE_RATE_OPTIONS_FILTERS_STEP_2: "2/3 Filters",
    TRENDS_ABSENCE_RATE_OPTIONS_COLUMNS: "Columns",
    TRENDS_ABSENCE_RATE_OPTIONS_COLUMNS_STEP_3: "3/3 Columns",
    TRENDS_ABSENCE_RATE_OPTIONS_GROUP_BY: "Group By",
    TRENDS_ABSENCE_RATE_OPTIONS_GROUP_BY_STEP_3: "3/4 Group By (Select One)",
    TRENDS_ABSENCE_RATE_OPTIONS_COMPARATOR: "Comparator",
    TRENDS_ABSENCE_RATE_OPTIONS_COMPARATOR_STEP_4: "4/4 Comparator",
    TRENDS_ABSENCE_RATE_HEADLINES_LABEL: "Absence Trend: {type}",
    TRENDS_ABSENCE_RATE_GROUP_BY: "Selected Group By",
    TRENDS_ABSENCE_RATE_PERCENTS: "Target Absence Rate: {value}%",
    TRENDS_ABSENCE_RATE_EXCLUSIONS_LABEL: "There are {value} Absence Rate Exclusions",
    TRENDS_ABSENCE_RATE_EXCLUSIONS: "Absence Rate Exclusions",
    TRENDS_ABSENCE_RATE_DATE_EXCLUDED: "Date Excluded",
    TRENDS_ABSENCE_RATE_PERIOD_COMPARISONS: "Period on Period Comparisons",
    TRENDS_COMPLIANCE_REPORT_LABEL: "New Compliance Trends Report",
    TRENDS_COMPLIANCE_SECTION_OPTIONS: "Areas, Filters, Group By & Comparator",
    TRENDS_COMPLIANCE_OPTIONS_AREAS: "Areas",
    TRENDS_COMPLIANCE_OPTIONS_AREAS_STEP_1: "1/4 Areas",
    TRENDS_COMPLIANCE_OPTIONS_FILTERS: "Filters",
    TRENDS_COMPLIANCE_OPTIONS_FILTERS_STEP_2: "2/4 Filters",
    TRENDS_COMPLIANCE_OPTIONS_GROUP_BY: "Group By",
    TRENDS_COMPLIANCE_OPTIONS_GROUP_BY_STEP_3: "3/4 Group By (Select One)",
    TRENDS_COMPLIANCE_OPTIONS_COMPARATOR: "Comparator",
    TRENDS_COMPLIANCE_OPTIONS_COMPARATOR_STEP_4: "4/4 Comparator",
    TRENDS_SECTION_COMPLIANCE: "Compliance Trends",
    TRENDS_COMPLIANCE_HEADLINES_LABEL: "Compliance Trend: {trendName}",
    TRENDS_COMPLIANCE_GROUP_BY: "Selected Group By",
    TRENDS_COMPLIANCE_HIDE_FRACTIONS: "Hide Fractions",
    TRENDS_COMPLIANCE_SHOW_FRACTIONS: "Show Fractions",
    TRENDS_COMPLIANCE_HIDE_TOTALS: "Hide Totals",
    TRENDS_COMPLIANCE_SHOW_TOTALS: "Show Totals",
    TRENDS_SLA_PERFORMANCE_REPORT_LABEL: "New SLA Performance Report",
    TRENDS_SLA_PERFORMANCE_SECTION_OPTIONS: "Areas, Filters, Period Type & Comparator",
    TRENDS_SLA_PERFORMANCE_OPTIONS_AREAS: "Areas",
    TRENDS_SLA_PERFORMANCE_OPTIONS_AREAS_STEP_1: "1/4 Areas",
    TRENDS_SLA_PERFORMANCE_OPTIONS_FILTERS: "Filters",
    TRENDS_SLA_PERFORMANCE_OPTIONS_FILTERS_STEP_2: "2/4 Filters",
    TRENDS_SLA_PERFORMANCE_OPTIONS_PERIOD_TYPE: "Period Type",
    TRENDS_SLA_PERFORMANCE_OPTIONS_PERIOD_TYPE_STEP_3: "3/4 Period Type",
    TRENDS_SLA_PERFORMANCE_OPTIONS_COMPARATOR: "Comparator",
    TRENDS_SLA_PERFORMANCE_OPTIONS_COMPARATOR_STEP_4: "4/4 Comparator",
    TRENDS_SLA_PERFORMANCE_COMPLIANCE: "SLA Performance",
    TRENDS_SLA_PERFORMANCE_PERIOD: "Period",
    TRENDS_SPOTLIGHT_SECTION_OPTIONS: "Areas, Filters & Comparator",
    TRENDS_SPOTLIGHT_OPTIONS_AREAS: "Areas",
    TRENDS_SPOTLIGHT_OPTIONS_AREAS_STEP_1: "1/3 Areas",
    TRENDS_SPOTLIGHT_OPTIONS_FILTERS: "Filters",
    TRENDS_SPOTLIGHT_OPTIONS_FILTERS_STEP_2: "2/3 Filters",
    TRENDS_SPOTLIGHT_OPTIONS_COMPARATOR: "Comparator",
    TRENDS_SPOTLIGHT_OPTIONS_COMPARATOR_STEP_3: "3/3 Comparator",
    TRENDS_ABSENCE_REASON_REPORT_LABEL: "New Absence Reason Trends Report",
    TRENDS_ABSENCE_REASON_SECTION_TITLE_TOP5_REASONS_FOR_ABSENCE: "Top 5 Reasons for Absence",
    TRENDS_ABSENCE_REASON_SECTION_TITLE_TOP5_REASON_TREND: "Top 5 Reason Trend",
    TRENDS_ABSENCE_REASON_PROFILE: "Absence Reason Profile: {reason}",
    TRENDS_ABSENCE_REASON_MEASURE_TOTAL_DAYS_LOST: "Total Days Lost",
    TRENDS_ABSENCE_REASON_MEASURE_ABSENCE_SPELLS: "Absence Spells Reported",
    TRENDS_ABSENCE_REASON_MEASURE_AVERAGE_DURATION: "Average Duration",
    TRENDS_ABSENCE_REASON_MEASURE_DAYS_LOST_PER_EMPLOYEE: "Days Lost per Employee (DLPE)",
    TRENDS_ABSENCE_REASON_CATEGORY_DETAILS_TITLE: "Category Details",
    TRENDS_ABSENCE_REASON_DLPE_BY_GENDER_TITLE: "DLPE by Gender",
    TRENDS_ABSENCE_REASON_DLPE_BY_AGE_GROUP_TITLE: "DLPE By Age Group",
    TRENDS_ABSENCE_REASON_SECTION_OPTIONS: "Areas, Filters, Columns & Comparator",
    TRENDS_ABSENCE_REASON_OPTIONS_AREAS: "Areas",
    TRENDS_ABSENCE_REASON_OPTIONS_AREAS_STEP_1: "1/4 Areas",
    TRENDS_ABSENCE_REASON_OPTIONS_FILTERS: "Filters",
    TRENDS_ABSENCE_REASON_OPTIONS_FILTERS_STEP_2: "2/4 Filters",
    TRENDS_ABSENCE_REASON_OPTIONS_COLUMNS: "Columns",
    TRENDS_ABSENCE_REASON_OPTIONS_COLUMNS_STEP_3: "3/4 Columns",
    TRENDS_ABSENCE_REASON_OPTIONS_COMPARATOR: "Comparator",
    TRENDS_ABSENCE_REASON_OPTIONS_COMPARATOR_STEP_4: "4/4 Comparator",
    TOP_5_ABSENCE_REASONS: "Top 5 Absence Reasons",
    MONTHLY_TOP_REASONS: "Absence Trend - Top 5 Reasons",
    ABSENCE_PROFILE: "Absence Profile",
    ABSENCE_SUMMARY: "Absence Summary",
    DLPE_BY_GENDER: "DLPE by Gender",
    DLPE_BY_AGE_GROUP: "DLPE by Age Group",
    ABSENCE_SPELLS_REPORTED: "Absence Spells Reported",
    AVERAGE_DURATION: "Average Duration",
    DAYS_LOST_PER_EMPLOYEE_DLPE: "Days Lost per Employee (DLPE)",
    RTW_COMPLIANCE_PERCENTAGE: "RTW Compliance %",
    COMPLIANCE_PERCENTAGE: "Compliance %",
    KEY_EMPLOYEES: "Key Employees",
    JUMP_TO: "Jump to:",
    DEPARTMENT_STATISTICS_DTO: "Department Avg.",
    DEPARTMENT_STATISTICS_DTO_TOOLTIP:
      "This is the average of all employees who are currently in the same department(s) as the selected employee and who were active in the date range selected above. Note that the selected employee is not included in the department average figures.",
    DEPARTMENT_STATISTICS_PERCENT_BASED_DTO: "% v Dept",
    ORGANIZATION_STATISTICS_DTO: "Organisation Avg.",
    ORGANIZATION_STATISTICS_DTO_TOOLTIP:
      "This is the average for all employee who were active during the date range selected above. Note that the selected employee is not included in the organisation average figures.",
    ORGANIZATION_STATISTICS_PERCENT_BASED_DTO: "% v Org",
    TOTAL_ABSENCES_ACTIVE: "Total Absences Active in Period",
    SHORT_TERM_ABSENCES_ACTIVE: "Short Term Absences Active in Period",
    LONG_TERM_ABSENCES_ACTIVE: "Long Term Absences Active in Period",
    TOTAL_ABSENCES_STARTED: "Total Absences Started in Period",
    SHORT_TERM_ABSENCES_STARTED: "Short Term Absences Started in Period",
    LONG_TERM_ABSENCES_STARTED: "Long Term Absences Started in Period",
    TOTAL_WORKING_DAYS_LOST: "Total Working Days Lost",
    SHORT_TERM_WORKING_DAYS_LOST: "Short Term Working Days Lost",
    LONG_TERM_WORKING_DAYS_LOST: "Long Term Working Days Lost",
    TOTAL_CALENDAR_DAYS_LOST: "Total Calendar Days Lost",
    SHORT_TERM_CALENDAR_DAYS_LOST: "Short Term Calendar Days Lost",
    LONG_TERM_CALENDAR_DAYS_LOST: "Long Term Calendar Days Lost",
    PERCENTAGE_OF_ABSENCE_RATES: "% Absence Rates",
    PERCENTAGE_OF_ABSENCES_REPORTED_LATE: "% Absences Reported Late",
    PERCENTAGE_OF_ABSENCES_CLOSED_LATE: "% Absences Closed Late",
    PERCENTAGE_OF_FIT_NOTE_COMPLIANCE: "% Fit Note Compliance",
    NUMBER_OF_DAYS: "Number of Days",
    ABSENCE_REPORTING_COMPLIANCE: "Absence Reporting Compliance",
    ABSENCE_CLOSING_COMPLIANCE: "Absence Closing Compliance",
    FIT_NOTE_COMPLIANCE: "Fit Note Compliance",
    TOTAL_EMPLOYEE_PER_STAGE_MONITORING_PROCESS:
      "Total Employee Per Stage of the Absence Monitoring Process",

    // Employees
    EMPLOYEE_DETAILS: "Employee Details",
    ABSENCE_STATISTICS: "Absence Statistics",
    STATISTICS: "Statistics",
    STATISTICS_WITH_NAME: "{name}: Statistics",
    NOTES_WITH_NAME: "{name}: Notes",
    ABSENCE_NOTES: "Absence Notes",
    ABSENCE_STATISTICS_WITH_NAME: "{name}: Absence Statistics",
    ABSENCE_NOTES_WITH_NAME: "{name}: Absence Notes",
    DOCUMENTS_WITH_NAME: "{name}: Documents",
    NEED_TO_CONTACT_DESCRIPTION:
      "Unfortunately, we do not yet have a personal phone number that can be shared for this employee.",
    GENERAL_DOCUMENTS_DESCRIPTION:
      "These are documents that relate to the employee but have no connection to a specific absence they have reported.",
    ABSENCE_SPECIFIC_DOCUMENTS: "Absence Specific Documents",
    ABSENCE_SPECIFIC_DOCUMENTS_DESCRIPTION:
      "These are documents that have been uploaded to a specific absence record. Clicking on the related absence ID will open the relevant absence record.",
    NOTIFICATION_DETAILS_WITH_NAME: "{name}: Notification Details",
    NOTIFICATIONS_SENT_TO_EMPLOYEE: "{name}'s notifications are sent to: ",
    NOTIFICATIONS_INDIVIDUAL_CONTACT_FOR_EMPLOYEE:
      "{name} is an Individual Notification contact for: ",
    NOTIFICATIONS_DEPARTMENT_CONTACT_FOR_EMPLOYEE:
      "{name} is a Department Notification Contact for: ",
    REPORT_EMPLOYEE_NAME: "Employee Name",
    DOCUMENT_ID: "Document ID",
    DOCUMENT_TYPE: "Document Type",
    DOCUMENT_NAME: "Document Name",
    APPRAISAL_FORM: "Appraisal form",
    FILE_NOTE: "File note",
    FIT_NOTE: "Fit note",
    INTERVIEW_FORM: "Interview form",
    LETTER: "Letter",
    HIDE: "Hide",
    SHOW: "Show",
    DELETE_DOCUMENT: "Delete Document",
    DELETE_DOCUMENT_CONFIRMATION: "Are you sure would like to delete this document?",
    PERIOD_START_DATE: "Period Start Date",
    PERIOD_END_DATE: "Period End Date",
    CANCELLED_ABSENCES: "Cancelled Absences",
    RELATED_ABSENCE: "Related Absence",

    // Managers
    REPORT_MANAGER_NAME: "Manager Name",
    ACCOUNT_CREATED_BY: "Account Created By",
    EDIT_ACCOUNT: "Edit Account",
    PORTAL_USAGE: "Portal Usage",
    SYSTEM_LOGINS: "System Logins in the last 13 Weeks",
    TIMES_RUN: "Times Run",
    LAST_USED: "Last Used",
    TIMES_REPORT_HAS_BEEN_RUN: "Times Each Report Has Been Run",
    TOTAL_COMPLIANCE_PERCENTAGE: "Total Compliance",
    RTW_SUBMITTED: "RTW Submitted",
    RTW_COMPLIANT: "RTW Compliant",
    REFERRALS_COMPLETED: "Referrals Completed",
    REFERRALS_COMPLIANT: "Referrals Compliant",
    REFERRALS_COMPLIANCE_PERCENTAGE: "Referrals Compliance %",
    ALERTS_REVIEWED: "Alerts Reviewed",
    REVIEWS_COMPLIANT: "Reviews Compliant",
    ABSENCE_MONITORING_PERCENTAGE: "Absence Monitoring %",
    COMPLIANCE_RATES_PER_PERIOD: "Compliance Rates Per Period",
    TIMES_USED: "Times Used",
    PERCENTAGE_OF_TOTAL: "% of Total",
    REASONS_FOR_RTW_NON_COMPLAINCE: "Reasons for RTW Non Compliance",
    PERCENTAGE: "Percentage",
    REASONS_FOR_DECLINED_REFERRALS: "Reasons for Declined Referrals",
    EMPLOYEES_AND_NOTIFICATIONS: "Employees and Notifications",
    EMPLOYEES_AND_NOTIFICATIONS_SIDEBAR: "Employees and\nNotifications",
    SMS_ONLY_NOTIFICATION: "Sms only",
    STANDARD_NOTIFICATION: "Standard",

    // My Notifications
    MY_NOTIFICATION_INBOX: "My Notification Inbox",
    YOUR_RECENT_NOTIFICATIONS: "Your Recent Notifications",
    SEARCH_NOTIFICATIONS: "Search Notifications",
    NEW_WARNING: "NEW!",
    SELECT_NOTIFICATION_AT_LEFT: "Select a notification at left",
    NOTIFICATION_DATA_EMPTY: "Notification data is empty",

    // My Tasks
    SELECT_A_TASK_FROM_THE_LEFT: "Select a task from the left",
    YOU_HAVE_NO_OUTSTANDING_TASKS: "You have no outstanding tasks",
    DUE: "Due",
    OVERDUE: "Overdue",
    TODO: "Todo",
    DUE_TODAY: "Due Today",
    SHOWING_ALL: "Showing All",
    GROUPED_BY_ABSENCE: "Grouped By Absence",
    SHOW_TASKS: "Show Tasks",
    HIDE_TASKS: "Hide Tasks",
    ACTION_ID: "Action ID",
    ABSENCE_START: "Absence Start",
    WHAT_WAS_THE_CAUSE_OF_YOUR_ABSENCE: "What was the cause of your absence?",
    CAUSE_PLACEHOLDER: "Cause...",
    DID_YOU_SEE_A_GP_DURING_YOUR_ABSENCE: "Did you see a GP during your absence?",
    DID_YOU_CONTACT_YOUR_OH_DURING_YOUR_ABSENCE: "Did you contact your OH during your absence?",
    PREFER_NOT_TO_SAY: "Prefer not to say",
    DID_YOU_USE_ANY_OF_THE_FOLLOWING_SERVICES_TO_HELP_YOU:
      "Did you use any of the following services to help you:",
    COUNSELLING: "Counselling",
    INTRANET: "Intranet",
    STAFF_HELP_LINE: "Staff Help Line",
    ANYTHING_ELSE_YOU_WOULD_LIKE_TO_SAY_ABOUT_YOUR_ABSENCE:
      "Anything else you would like to say about your absence?",
    EXTRA_INFO_PLACEHOLDER: "Extra info...",
    QUESTION_DATE_AND_LONG_LABEL_HERE_AT_THE_TOP_OF_THE_FIELD_WRAPPING_ON_2_LINES:
      "Question Date and Long Label Here at the Top of the Field Wrapping on 2 Lines",
    DATE_INTERVIEW_COMPLETED: "Date & Time Interview Completed",
    PRINT: "Print",
    PRINT_FORM: "Print Form",
    TASKS_DETAILS_SAVE_DRAFT: "Save Draft",
    PAGE_CURRENT_OF_TOTAL: "Page {currentPage} of {pagesCount}",
    FILTER_QUEUE: "Filter Queue",
    RTW_INTERVIEW: "RTW Interview",
    ABSENCE_MONITORING_REVIEW: "Absence Monitoring Review",
    TASKS_INSUFFICIENT_DATA:
      "This absence monitoring task cannot be displayed due to an error in the absence monitoring service configuration. Please check with your administrators, or get in touch with GoodShape via the Help page.",
    TASK_DETAILS: "Task Details",
    TASK_IN_PROGRESS: "(In Progress)",
    LATE_REASON: "Late Reason",
    LATE_SUBMISSION: "Late Submission",
    SET: "Set",
    LATE_REASON_DESCRIPTION:
      "Please note that this Return to Work Interview has not been completed within your organisation's target of {lateTimeCount}. Please select from the list below the reason for your late submission.",
    DAYS_COUNT: "{daysCount} days",
    HOURS_COUNT: "{hoursCount} hours",
    DAYS_AND_HOURS_COUNT: "{daysCount} days and {hoursCount} hours",
    DECISION_BY: "Decision Made By",
    DATE_OF_NEXT_REVIEW: "Date Of Next Review",
    OUTSTANDING_ALERTS: "Outstanding Alerts",
    LATEST_EVENT_DESCRIPTION: "Latest Event",
    NO_ACTION_COUNT: "Times No Action Taken",
    MOST_COMMON_NO_ACTION_REASON: "Most Common Reason For Taking No Action",
    SPELLS_IN_LAST_12_MONTHS: "Spells In Last 12 Months",
    ABSENCE_SPELLS: "Spells In Last 12 Months",
    DAYS_LOST_IN_LAST_12_MONTHS: "Days Lost In Last 12 Months",
    AGE: "Age",

    // Navigation
    NAVIGATION_TOOLS: "Tools",
    NAVIGATION_DASHBOARD: "Dashboard",
    NAVIGATION_OVERVIEW: "Overview",
    NAVIGATION_ABSENCE_NOW: "Absence Now",
    NAVIGATION_CHANGES_AWAITING: "Changes Awaiting",
    NAVIGATION_TASKS: "Tasks",
    NAVIGATION_NOTIFICATIONS: "Notifications",
    NAVIGATION_ABSENCE_INDEX: "Absence Index",
    NAVIGATION_PROFILE: "Profile",
    NAVIGATION_REPORTS: "Reports",
    NAVIGATION_REPORTS_OVERVIEW: "Reports Overview",
    NAVIGATION_ABSENCE_DETAILS: "Absence Details",
    NAVIGATION_MANAGER_DETAILS: "Manager Details",
    NAVIGATION_MONITORING_DETAILS: "Monitoring Details",
    NAVIGATION_RTW_DETAILS: "RTW Details",
    NAVIGATION_REFERRAL_DETAILS: "Referral Details",
    NAVIGATION_ALERT_DETAILS: "Alert Details",
    NAVIGATION_FOCUS_LISTS: "Focus Lists",
    NAVIGATION_FOCUS_LISTS_OVERVIEW: "Focus Lists Overview",
    NAVIGATION_EMPLOYEE_FOCUS_LIST: "Employee Focus List",
    NAVIGATION_DEPARTMENT_FOCUS_LIST: "Department Focus List",
    NAVIGATION_MANAGER_FOCUS_LIST: "Manager Focus List",
    NAVIGATION_TRENDS: "Trends",
    TREND_REPORTS: "Trend Reports",
    NEW_ACTIVE_AND_CLOSED_CASES: "New, Active and Closed Cases",
    NAVIGATION_TRENDS_OVERVIEW: "Trends Overview",
    NAVIGATION_ABSENCE_RATE_TRENDS: "Absence Rate Trends",
    NAVIGATION_ABSENCE_REASON_TRENDS: "Absence Reason Trends",
    NAVIGATION_COMPLIANCE_TRENDS: "Compliance Trends",
    NAVIGATION_SLA_PERFORMANCE: "SLA Performance",
    NAVIGATION_PLANNED_LEAVE_TRENDS: "Planned Leave Trends",
    NAVIGATION_EMPLOYEES: "Employees",
    NAVIGATION_TRAINING: "Training Materials",
    MY_TASKS: "My Tasks",
    NAVIGATION_ABSENCE_DETAILS_DESCRIPTION:
      "Here you can look up a list of absence based upon a set criteria.",
    NAVIGATION_RTW_DETAILS_DESCRIPTION:
      "Here you can access all previously submitted RTW Interview forms, as well as all presently outstanding ones.",
    NAVIGATION_REFERRAL_DETAILS_DESCRIPTION:
      "Here you can access all wellbeing referral triggers that have been prompted along with the chosen outcome.",
    NAVIGATION_ABSENCES: "Absences",
    NAVIGATION_RTWS: "RTWs",
    NAVIGATION_ALERTS: "Alerts",
    NAVIGATION_MONITORING: "Monitoring",
    NAVIGATION_ABSENCE_MONITORING: "Absence Monitoring",
    NAVIGATION_REFERRALS: "Referrals",
    RISK_CRITERIA: "Risk Criteria:",
    RISK_SUMMARY: "Risk Summary:",
    TITLE_RISK_CRITERIA: "Risk Criteria",
    TITLE_SUMMARY: "Summary",
    HIGH_RISK_SUMMARY_TITLE: "High Risk Summary",
    FORECAST_PERIOD: "Forecast period",
    VERY_LOW_RISK: "Very Low Risk",
    MEDIUM_RISK: "Medium Risk",
    LOW_RISK: "Low Risk",
    HIGH_RISK: "High Risk",
    VERY_HIGH_RISK: "Very High Risk",
    SIX_MONTHS: "6 Months",
    KEY: "Key",
    COMPLAINCE: "Complaince",
    RANK: "Rank",
    TWELVE_MONTHS: "12 Months",
    TWENTYFOUR_MONTHS: "24 Months",
    THIRTYSIX_MONTHS: "36 Months",
    RISK_REPORT: "Risk Report: {reportName}",
    FORECASTS_WITH_NAME: "{name}: Forecasts",
    FORECASTS: "Forecasts",
    EMPLOYEE_NAME_ABSENCE_DETAILS: "{name} : Absence Details",
    ESTIMATED_DURATION_TITLE: "{selectedTerm}: Estimated Duration (Working Days)",
    LONG_TERM_ABSENCE: "Long Term Absence",
    MEDIUM_TERM_ABSENCE: "Medium Term Absence",
    ESTIMATED_DURATION_CHART_H_AXIS_VALUE: "Estimated Days Lost Before Return to Work",
    ESTIMATED_DURATION_CHART_V_AXIS_VALUE: "% Probability",
    VERY_LOW_LIKELIHOOD_RETURNED_AFTER: "Very Low Likelihood",
    LOW_LIKELIHOOD_RETURNED_AFTER: "Low Likelihood",
    MEDIUM_LIKELIHOOD_RETURNED_AFTER: "Medium Likelihood",
    HIGH_LIKELIHOOD_RETURNED_AFTER: "High Likelihood",
    VERY_HIGH_LIKELIHOOD_RETURNED_AFTER: "Very High Likelihood",
    HIGHEST_RISK_DEPARTMENTS: "Highest Risk Departments",
    TITLE_RISK_TIMELINE: "% Risk Timeline",
    DEPARTMENTS_WITH_MOST_RISK: "Departments With Most Risk",
    EMPLOYEE_BY_RISK_RATING: "Employee By Risk Rating",
    RISK_TIMELINE_DESCRIPTION:
      "The chart below shows a count of the number of employees that match your risk criteria per month.",
    NAVIGATION_MI_PRESENTATIONS: "MI Presentations",

    // Reports Overview
    REPORTS_OVERVIEW_INTRO:
      "Here you can access a range of detailed reports that will help you to better understand and analyse absence within your team.",
    HOW_REPORTS_WORK_TITLE: "How do reports works?",
    HOW_REPORTS_WORK_DESCRIPTION:
      "Each report is designed to give you access to data on a specific absence related topic (such as absences, alerts or return to work interviews). The reports will only include data for employees that you are authorised to see and there are 3 ways that you can approach running each report:",
    ABSENCE_DETAILS_REPORT: "Absence Details Report",
    VISIT_TRAINING_CENTRE: "Visit Training Centre",
    NEED_GUIDANCE: "Need guidance?",
    NEED_GUIDANCE_DESCRIPTION:
      "Remember that you can revisit the Reports section of the Training Centre at any time to familiarise yourself with how they work and how they can help.",
    GOOD_PLACE_TO_START_TITLE: "Where is a good place to start?",
    GOOD_PLACE_TO_START_DESCRIPTION:
      "The Absence Details page will enable you to select one or multiple areas of your hierarchy, apply filters narrowing down your absence search criteria and select what columns of that criteria should be presented in the table of data when submitted.",
    GOOD_PLACE_TO_START_DESCRIPTION_BOTTOM:
      "This is an ideal report for understanding the current status of absence within your organisation.",
    HOW_REPORTS_WORK_DESCRIPTION_BOTTOM:
      "Whichever path you choose, you will see detailed absence information that you can review on screen or export to Excel.",
    RUN_REPORT: "Run a default report",
    RUN_PREVIOUSLY_SAVED_REPORT: "Run one of your own previously saved reports",
    CREATE_NEW_REPORT: "Create a brand new report from scratch",
    DISABLED_DOT_TEXT: "This feature is not enabled for your organisation.",

    // GoodShape Index
    THE_FIRST_CARE_INDEX: "The GoodShape Index",
    ABSENCE_TOTALS: "Absence Totals",
    COMPARE_ABSENCE_RATES:
      "See how your absence rates compare against sector and national averages!",
    EXPORT_TO_PDF: "Export To PDF",
    EXPORT_TO_EXCEL: "Export To Excel",
    CUSTOMISE_YOUR_BENCHMARKING_VIEW: "Customise Your Benchmarking View:",
    ABSENCE_TYPE: "Absence Type",
    ABSENCE_TYPES: "Absence Types",
    RECORD_BANK_HOLIDAYS: "Record Absence on Bank Holidays",
    ALLOW_ABSENCE_REOPEN: "Allow Absences to be Re-Opened",
    TIME_PERIOD_TO_REOPEN: "Time Period in Which Absences Can be Re-Opened",
    MINIMUM_ABSENCE_DURATION: "Minimum Absence Duration (Minutes)",
    ADVANCE_ABSENCE_CLOSING: "Closing Absences in Advance (Hours)",
    ABSENCE_LEVELS: "Absence Levels",
    ABSENCE_REASONS: "Absence Reasons",
    ABSENCE_REASON: "Absence Reason",
    ABSENCE_MEASURE: "Absence Measure",
    RECORD_ACCESS: "Record Access",
    YOUR_RATE: "Your Rate",
    YOUR_ORGANISATION: "Your Organisation",
    INDUSTRY_AVERAGE: "Industry Average",
    NATIONAL_AVERAGE: "National Average",
    AGE_GROUP: "Age Group",
    AGE_GROUP_BAND: "Age Group Band",
    GENDER: "Gender",
    WEEKDAY: "Weekday",
    STAFF_GROUP: "Staff Group",
    BENCHMARK: "Benchmark: {title}",
    DAYS_LOST_PER_EMPLOYEE_RATE: "Days Lost Per Employee Rate",
    DAYS_LOST_PER_EMPLOYEE_FOR_TOP_FOUR_ABSENCE_REASONS:
      "Days Lost Per Employee for Top 4 Absence Reasons",
    DAYS_LOST_PER_EMPLOYEE_BY_AGE_GROUP: "Days Lost Per Employee By Age Group",
    ABSENCE_TRENDS: "Absence Trends",
    BENCHMARK_TYPE: "Benchmark Type",
    PERIOD_TYPE: "Period Type",
    COMPARATORS: "Comparator(s)",
    COMPARATOR: "Comparator",
    BENCHMARKING_PARAMETERS: "Benchmarking Parameters",
    BENCHMARKING_RESULTS: "Benchmarking Results",
    BENCHMARKING_REPORT_BENCHMARK_TYPE: "Benchmarking Report: {benchmarkType}",

    // Referral Tracker
    NEW_REFERRALS: "New Referrals",
    REFERRAL_TRACKER: "Referral Tracker",
    EMPLOYEE_REFERRAL: "Employee Referral",
    MANAGER_REFERRAL: "Manager Referral",
    MANUAL_REFERRAL: "Manual Referral",
    SELECTED_REFERRAL_EMPLOYEE_NAME: "Employee Name",
    SELECTED_REFERRAL_DEPARTMENT: "Department",
    SELECTED_REFERRAL_ABSENCE_START: "Absence Start",
    SELECTED_REFERRAL_RTW_DATE: "RTW Date",
    SELECTED_REFERRAL_REFERRAL_REASON: "Referral Reason",
    SELECTED_REFERRAL_WELLBEING_SUPPLIER: "Wellbeing Supplier",
    REFERRAL_DECISION: "Referral Decision",
    REFERRAL_DECISION_ACCEPT_REFUSE_DESCRIPTION:
      "Please confirm if you have accepted or declined this referral?",
    REFERRAL_DECISION_ACKNOWLEDGE_DESCRIPTION:
      "Please confirm that you have accepted this referral:",
    ACCEPTED: "Accepted",
    DECLINED: "Declined",
    ACCEPT_REFUSE: "Accept/Refuse",
    ACKNOWLEDGE: "Acknowledge",
    TOTAL_COUNT: "Total: {count}",
    OVERDUE_COUNT: "Overdue: {count}",
    SEE_ARCHIVE: "See Archive",
    REFERRAL_TYPE: "Referral Type",
    REPORT_FILTERS: "Report Filters",
    REFERRAL_ID: "Referral ID",
    EMPLOYEE: "Employee",
    REFERRAL_REASON: "Referral Reason",
    DATE_REFERRED: "Date Referred",
    DATE_REVIEWED: "Date Reviewed",
    OUTCOME: "Outcome",
    ID: "ID",
    ADMINISTER_EMPLOYEE_RECORD: "Administer Employee Record",
    COMPANY: "Company",
    EXCLUSIONS: "Exclusions",
    ALERT_EXCLUSIONS: "Alert Exclusions",
    EXCLUDE_EMPLOYEE_FROM_ALERTS: "Exclude Employee from Alerts",
    SPECIFY_ALERT_EXCLUSION: "Specify Alert Exclusion",
    TOTAL_ABSENCE_RATE: "Total Absence Rate",
    TOTAL_HOURS_LOST: "Total Hours Lost",
    TOTAL_DLPE: "Total Days Lost Per Employee (DLPE)",
    TOTAL_RTW_COMPLIANCE: "Total RTW Compliance",
    REASONS_BY_WORKING_HOURS_LOST: "Top 5 Absence Reasons by Working Hours Lost per Month",
    REASONS_BY_SPELLS: "Top 5 Absence Reasons by Spells Started per Month",
    TOTAL_REASONS_BY_WORKING_HOURS_LOST: "Total Working Hours Lost by Absence Reasons",
    TOTAL_REASONS_BY_SPELLS: "Total Spells Started by Absence Reasons",
    INCLUDE_DISABLED: "Include Disabled",
    INCLUDE_EMPLOYEES_WITH_DISABILITY: "Include Disabled",
    ABSENCES_GREATER_THAN_DAYS: "Greater Than (Days)",
    ABSENCES_GREATER_THAN_DAY_TYPE: "Greater Than (Day Type)",
    LENGTH: "Length",
    SHOW_WORK_RELATED_ONLY: "Show Work Related Only",
    WORK_RELATED_ONLY: "Work Related Only",
    LEAST_ABSENCE_SPELLS: "Least absence spells",
    LEAST_DAYS_LOST: "Least days lost",
    MOST_ABSENCE_SPELLS: "Most absence spells",
    MOST_ALERTS_TRIGGERED: "Most alerts triggered",
    MOST_DAYS_LOST: "Most days lost",
    REASON_OVERVIEW: "Reason Overview",
    OPEN_ABSENCES_BY_ABSENCE_REASON: "Open Absences by Absence Reason",
    TASKS_OVERVIEW: "Tasks Overview",
    REASON_OVERVIEW_DESC:
      "The below report shows common reasons for today's current open absences, along with an indication of how much time will be lost.",
    CURRENT_OPEN_ABSENCES_PER_REASON: "Current Open Absences Per Reason",
    PERCENTAGE_OF_TOTAL: "% of Total",
    EST_AVRG_LEN_ABS: "Average Length (Days)",
    EST_TOTAL_DAYS_LOST_FOR_ABS: "Total Days Lost",
    REASON: "Reason",
    HIGHEST_ABSENCE_PERCENTAGE: "Highest absence percentage",
    HIGHEST_RTW_COMPLIANCE_PERCENTAGE: "Highest RTW Compliance percentage",
    LOWEST_RTW_COMPLIANCE_PERCENTAGE: "Lowest RTW Compliance percentage",
    MY_RTW_FORMS_ONLY: "My RTW Forms Only",
    COMPLETED_LATE: "Completed late",
    COMPLETED_ON_TIME: "Completed on time",
    NOT_COMPLETED_ON_TIME: "Not completed on time",
    EXPIRED: "Expired",
    OUTSTANDING: "Outstanding",
    REFERRAL_OUTCOME: "Referral Outcome",
    REASON_FOR_REFERRAL: "Reason For Referral",
    APPROVABLE_SUMMARY: "Approvable Summary",
    ABSENCE_SPELLS_STARTED: "Absence Spells Started",
    AVERAGE_ABSENCE_LENGTH: "Average Absence Length",
    COST_OF_ABSENCE: "Cost Of Absence",
    DETAILED_REASON: "Detailed reason",
    WEEKLY: "Weekly",
    HIGHEST_MONITORING_COMPLIANCE: "Highest monitoring compliance",
    HIGHEST_REFERRAL_COMPLIANCE: "Highest referral compliance",
    HIGHEST_RTW_COMPLIANCE: "Highest RTW Compliance",
    LOWEST_MONITORING_COMPLIANCE: "Lowest monitoring compliance",
    LOWEST_REFERRAL_COMPLIANCE: "Lowest referral compliance",
    LOWEST_RTW_COMPLIANCE: "Lowest RTW Compliance",
    MOST_LOGINS: "Most Logins",
    LEAST_LOGINS: "Least Logins",
    MOST_OUTSTANDING_ACTIONS: "Most Outstanding Actions",
    OVERDUE_REFERRALS: "Overdue Referrals",
    ACTIVE_REFERRALS: "Active Referrals",
    CURRENT_ACTIVE_REFERRALS: "Current Active Referrals",
    REFERRALS_OLD_THEN: "Referrals < {num} Days Old",
    REFERRALS_OLDER_THEN_90: "Referrals Older Than 90 Days",
    LOG: "Log",
    CLOSED_REFERRALS: "Closed Referrals",
    LAST_NUMBER_OF_DAYS: "Last {num} Days",
    LINE_MANAGERS: "Line Managers",
    ABSENCE_HISTORY_LAST_10_ABSENCES: "Absence History (Last 10 Absences)",
    ACKNOWLEDGEMENT: "Acknowledgement",
    REFERRED_BY: "Referred By",
    RESPONSE: "Response",
    ACCEPT_REFERRAL_QUESTION: "Do you wish accept this referral:",
    SUPPLIER_REFERRAL_ACKNOWLEDGE_DECISION_TEXT: "Please acknowledge receipt of this referral:",
    SUPPLIER_REFERRAL_ACCEPT_REFUSE_DECISION_TEXT: "Do you wish to accept this referral?",
    SUPPLIER_REFERRAL_ACKNOWLEDGEMENT_DATE_TEXT: "This referral was acknowledged on:",
    DECLINED_BY: "Declined By",
    REASON_FOR_RECOMMENDED_REFERRAL: "Reason for Recommended Referral",
    REASON_DECLINED: "Reason Declined",
    DATE_DECLINED: "Date Declined",

    // Referral Task Statuses
    EMPLOYEE_DID_NOT_PROCEED: "Employee Did Not Proceed",
    EMPLOYEE_DID_NOT_ATTEND: "Employee Did Not Attend",
    EMPLOYEE_WITHDREW_CONSENT: "Employee Withdrew Consent",
    INCORRECT_REFERRAL: "Incorrect Referral",
    UNABLE_TO_CONTACT_EMPLOYEE: "Unable To Contact Employee",
    TRANSFERRED_TO_THIRD_PARTY: "Transferred To Third Party",
    EMPLOYEE_DECEASED: "Employee Deceased",
    EMPLOYEE_RTW_PERMANENTLY_ON_REDUCED_DUTIES: "Employee Rtw Permanently On Reduced Duties",
    EMPLOYEE_RTW_ON_FULL_DUTIES: "Employee Rtw On Full Duties",
    EMPLOYEE_RESIGNED: "Employee Resigned",
    ILL_HEALTH_RETIREMENT: "Ill Health Retirement",
    INAPPROPRIATE_REFERRAL: "Inappropriate Referral",
    RTW_ON_PHASED_RETURN: "Rtw On Phased Return",
    UNABLE_TO_PROCEED: "Unable To Proceed",
    NOT_RETURNED_TO_WORK: "Not Returned To Work",
    RTW_AND_UNDER_TREATMENT: "Rtw And Under Treatment",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
    DECLINE_REFERRAL: "Decline Referral",
    REFERRAL_DECLINED: "Referral Declined",
    REFERRAL_ACCEPTED: "Referral Accepted",
    ACCEPT_REFERRAL: "Accept Referral",

    ABSENCE_RATE: "Absence rate",
    DLPE: "DLPE",
    AGE_GROUPS: "Age Groups",
    ABSENCES_FILTER: "Absences Filter",
    ABSENCES_FILTER_TOOLTIP:
      "Selecting 'That Started' will return absences with an Absence Start Date within the Date Range. 'That Closed' will return absences where the employee closed their absence within the Date Range. 'With a RTW Date' returns absences with a Return to Work Date within the Date Range. Finally, 'That Were Active', returns absences where either the Absence Start Date or the RTW Date fall within the Date Range.",
    WITH_A_RTW_DATE: "With a Rtw Date",
    THAT_STARTED: "That started",
    THAT_WERE_ACTIVE: "That were active",
    MANAGERS_EMAIL: "Managers Email",
    POSITIONS: "Positions",
    DAYS_TO_COMPLETE: "Days To Complete",
    REASON_FOR_LATE_INTERVIEW: "Reason for late Interview",
    HOURS_TO_COMPLETE: "Hours To Complete",
    TRAINING_TILE_DESCRIPTION:
      "Here you can access a Glossary of Terms, FAQs and a series of downloadable user guides designed to help you get the best out of GoodShapeCentral.",
    REPORTING_VISIT_TRAINING: "Visit Training",
    CUSTOMER_SUPPORT: "Customer Support",
    CUSTOMER_SUPPORT_DESCRIPTION:
      "Need help with anything? If so, click here to email our Customer Support team.",
    CONTACT_US: "Contact us",
    ABSENCE_MONITORING_TASK: "Absence monitoring task",
    NUMBER_OF_RESULTS: "Results ({number})",
    GUIDE: "Guide",
    RTW_DATE_COMPLETE_TOOLTIP:
      "To enter the date and time you completed the RTW Interview please click on the calendar icon to the right. You will need to select the date, then the time and then press the Apply button.",
    ACCOUNT_ACTIVITY: "Account Activity",
    TASK_ID: "Task ID",
    DATE_DUE: "Date Due",
    TOTAL_OUTSTANDING_ACTIONS: "Total Outstanding Actions: {number}",
    TOTAL_OVERDUE_ACTIONS: "Total Overdue Actions: {number}",
    DAYS_AVAILABLE: "Days available",
    OPEN_ABSENCES: "Open Absences",
    CURRENT_OPEN_ABSENCES: "Current Open Absences",
    OPEN_ABSENCES_INFECTIOUS: "Open Absences (Infectious)",
    CORONAVIRUS_ABSENCES: "Coronavirus Absences",
    RECENT_ALERTS: "Recent Alerts",
    QUICK_INSIGHT: "Quick Insight",
    VIEW_ALL_REPORTS: "View All Reports",
    REPORTS_TITLE_DETAILS: "Details of all current, recent and historic absence activity.",
    FOCUS_LISTS_TITLE_DETAILS: "Quick Identification of the key areas in need of greater attention",
    TRENDS_TITLE_DETAILS: "Historic Analysis of how absence has changed over time.",
    RUN: "Run",
    REPORTS_NO_RESULTS_TEXT: "You have not built any reports yet.",
    INSIGHTS_ENABLES_YOU_TO_BUILD:
      "Insight enables you to build and save your own reports. To get started, click the Create New Report button above.",
    EDIT_SCOPE_FILTERS: "Scope and Filters",
    GENERATING: "Generating...",
    BV12_FTE_AVAILABLE: "BV12 FTE Available",
    BV12_FTE_DAYS_LOST: "BV12 FTE Days Lost",
    BV12_SCORE: "BV12 Score",
    REPEAT_SHIFT_PATTERN_TITLE_DAYS: "Repeat Shift Pattern",
    TARGET_DATE: "Target Date",
    FIRST_NAME_TOOLTIP:
      "This is used in conjunction with Employee Ref and Date of Birth to help identify employees throughout the system",
    LAST_NAME_TOOLTIP:
      "This is used in conjunction with Employee Ref and Date of Birth to help identify employees throughout the system",
    DEPARTMENT_TOOLTIP:
      "This is the department the employee is currently assigned to in your organisation structure. If the employee has two or more active positions in different departments, each department will appear separated by a comma.",
    START_DATE_TOOLTIP: "This is the date and time that the employee's absence started.",
    LAST_ABSENCE_DAY_TOOLTIP:
      "This is the last working day that will be missed by the employee as a result of their absence. For example, if an employee works only on Monday and Tuesday, and reports an absence for both days, their Last Absence Day will be the Tuesday and their Return to Work day will be the following Monday. If this field is blank it means a shift pattern has not yet been logged for this absence.",
    RTW_DATE_TOOLTIP:
      "RTW means 'Return to Work'. This is the date and time that the employee is expected to return to work (if the absence is OPEN) or the date they did return to work (if the absence is CLOSED).",
    DAYS_LOST_TOOLTIP:
      "This is the total Working Days Lost (WDL) for the absence. For example, if an employee reports an absence with a Start Date of Monday 1st and a RTW Date of Monday 8th, but they do not work on Tuesday, Fridays, Saturdays or Sundays, then the total working days lost would be 3 (as the only working days they missed were Monday, Wednesday and Thursday).",
    ABSENCE_TYPE_TOOLTIP: "This indicates the type of absence (Medical or Non-Medical).",
    ABSENCE_TYPE_FILTER_TOOLTIP:
      "Selecting 'All' will display Medical and Non-Medical absences within the chosen date range. Select 'Medical' or 'Non medical' to limit the results as required.",
    ABSENCE_REASON_TOOLTIP:
      "This is the reason classification assigned to the absence. If the employee did not give GoodShape permission to disclose the absence reason then the words 'Consent Withheld' will appear in place of the absence reason.",
    ABSENCE_STATUS_TOOLTIP:
      "This field confirms the current status of the absence. Overdue means the absence is still open but the RTW Date is in the past, meaning the employee has not updated their absence appropriately.",
    ABSENCE_STATUS_FILTER_TOOLTIP:
      "Selecting 'All' will display both Open and Closed absences within the chosen date range. Select 'Open' or 'Closed' will limit the results to just the chosen option.",
    ABSENCE_ID_TOOLTIP: "This is the unique ID of the absence for reference purposes.",
    HOURS_LOST_TOOLTIP:
      "This is the total Working Hours Lost (WHL) for this absence. It is calculated by adding up the hours lost on each day of the employees absence. For example, if an employee was absent for 8 hours on Monday, 6 hours on Tuesday and 8 hours on Wednesday, the Total Hours Lost for the absence as a whole would be 22 hours.",
    CALENDAR_DAYS_LOST_TOOLTIP:
      "This is the total Calendar Days Lost (CDL) for this absence. It is a count of the calendar days between the Absence Start date and the day before the RTW Date.",
    WORK_RELATED_TOOLTIP:
      "If this is a Yes it means the employee has indicated that the cause of their absence was work related.",
    DATE_REPORTED_TOOLTIP: "This is the date and time that the absence was reported to GoodShape.",
    LAST_UPDATED_TOOLTIP: "This is the date and time that the absence as most recently updated.",
    DATE_CLOSED_TOOLTIP:
      "This is the date and time that the absence was closed. Note that this field will appear blank for open absences.",
    WORKING_DAYS_IN_PERIOD_TOOLTIP:
      "This is the total working days by the employee in the report period and is not to be confused with the total days lost for the absence itself. For example, if the employee had 3 absences in the period which were 5, 10 and 6 days long respectively, the Total Working Days Lost in Period would be 21.",
    HOURS_DAYS_IN_PERIOD_TOOLTIP:
      "The same as Working Days in Period but calculated based on the Working Hours Lost instead.",
    CALENDAR_DAYS_IN_PERIOD_TOOLTIP:
      "The same as Working Days in Period but calculated based on the Calendar Days Lost instead.",
    DAYS_TILL_RETURN_TOOLTIP:
      "This is how many calendar days are left until the employee's RTW Date and Time.",
    SCHEDULED_TO_WORK_TODAY_TOOLTIP:
      "If this is a Yes it means that Today is a day the employee was scheduled to work. If it is a No then today is a non-working day for the employee that happens to fall within their period of absence.",
    BRADFORD_SCORE_TOOLTIP:
      "This confirms the employee's current Bradford Score. Note that the Bradford Score is calculated based upon Today, not upon the Start Date of the absence.",
    DAYS_LOST_LAST_12_MONTH_TOOLTIP:
      "This will confirm the Total Days Lost (TDL) for all absence reported by the employee within the last 12 months",
    FTE_TOOLTIP:
      "This field displays the FTE of the employee, which stands for Full Time Equivalent. Typically a full-time employee has an FTE of 1.00.",
    STAFF_GROUP_TOOLTIP:
      "This will confirm the Staff Group of the employee. If a Staff Group has not been assigned the field will appear blank.",
    DISABILITY_TOOLTIP:
      "This will say 'Yes' is the employee has a disability, or 'No' if they do not.",
    AGE_BRACKET_TOOLTIP: "This fields shows the Age bracket the employee is assigned to.",
    GENDER_TOOLTIP:
      "Selecting 'All' will display all absences within the chosen date range, regardless of the gender of the employee that reported it. Select 'Male', 'Female' or 'Other' to limit the results when required.",
    GENDER_FILTER_TOOLTIP:
      "Selecting 'All' will display all absences within the chosen date range, regardless of the gender of the employee that reported. Select 'Male', 'Female' or 'Other' to limit the results when required.",
    ABSENCE_LENGTH: "Absence Length",
    ABSENCE_LENGTH_TOOLTIP:
      "Selecting 'All' will display all absences within the chosen date range, regardless of their length. Selecting 'Long Term' or 'Short Term' will limit the results to only those absences which meet the chosen length criteria.",
    ABSENCES_GREATER_THAN_DAY_TYPE_TOOLTIP:
      "The filter lets you limit the results to only those absences which last longer than a specific number of days and is used in conjunction with the 'Absences Greater Than Days' filter. This means, for example, that you would limit the report to only show absences where the time lost is greater than 100 calendar days.",
    STAFF_GROUPS_FILTER_TOOLTIP:
      "The report will include all Staff Groups by default. However, you can limit the report to specific staff groups using this filter. If your organisation does not use the Staff Group feature the list of options will be blank.",
    ABSENCE_REASONS_FILTER_TOOLTIP:
      "The report will include all Absence Reasons by default. However, you can limit the report to specific reasons using this filter. By clicking the 'Add' button you can select a reason from a drop down list of options. You are free to add as many reasons as you require.",
    AGE_GROUPS_TOOLTIP:
      "The report will include all Age Groups  by default. However, you can limit the report to specific age groups using this filter.",
    FROM_DATE_TOOLTIP:
      "When the Date Range filter is set to 'Custom' you will need to manually choose a From Date as the start of your report period.",
    TO_DATE_TOOLTIP:
      "When the Date Range filter is set to 'Custom' you will need to manually choose a To Date as the end of your report period. Note that the date you choose here will be included in the scope of the report.",
    INCLUDE_LEAVERS_TOOLTIP:
      "A Leaver is an employee who is no longer actively employed by your organisation. By default, Leaver employees are excluded from reports. If you want leavers to be included in your report set this value to 'Yes'.",
    INCLUDE_EMPLOYEES_WITH_DISABILITY_TOOLTIP:
      "Selecting 'Yes' means that employees with and without a disability will be included in the report. Selecting 'No' will only return employees who do not have a disability.",
    SHOW_CONSENT_WITHHELD_ONLY: "Consent Withheld Absences Only",
    SHOW_CONSENT_WITHHELD_ONLY_TOOLTIP:
      "Selecting 'No' will display all absences within the chosen date range, regardless of consent status. Selecting 'Yes' means that only Consent Withheld absences will appear in the report. Consent Withheld means that the employee did not give permission to GoodShape to share the reason for their absence.",
    SHOW_WORK_RELATED_ONLY_TOOLTIP:
      "Selecting 'No' will display all absences within the chosen date range, regardless of their Work Related status. Select 'Yes' to only display the absences where the employee has said the cause was Work Related.",
    ABSENCES_GREATER_THAN_DAYS_TOOLTIP:
      "The filter lets you limit the results to only those absences which last longer than a specific number of days and is used in conjunction with the 'Absences Greater Than Day Type' filter. This means, for example, that you would limit the report to only show absences where the time lost is greater than 100 calendar days.",
    DATE_RANGE: "Date Range",
    DATE_RANGE_FILTER_TOOLTIP:
      "Custom allows you to choose your own dates. All other options let you select a defined time period which is ideal for reports you want to run on a regular basis or a set schedule. Note that today is included in the Last 7 Days, Last 30 Days and Last 90 Days options.",
    SCHEDULE_REPORT: "Schedule Report",
    SCHEDULE_REPORT_TOOLTIP:
      "Here you can set-up a schedule for this report to be emailed to you automatically on either a daily, weekly or monthly basis. Security restrictions you need to take note off will be detailed below. Each report can only have one schedule.",
    SCHEDULE: `Schedule`,
    SECURITY_NOTICE: `Security Notice:`,
    SCHEDULE_REPORT_NOTICE_LINE_1: `Your report will be emailed to your Work Email Address: <strong>{workEmail}</strong>`,
    SCHEDULE_REPORT_NOTICE_LINE_2: `The Report will expire within <strong>{reportsExpiry}</strong> Days if you do not open it.`,
    SCHEDULE_REPORT_NOTICE_LINE_3: `If you fail to open this report <strong>{autoDisabling}</strong> times in a row it will be disabled.`,
    HISTORIC_REPORT: "Historic Report",
    HISTORIC_REPORT_PARAGRAPH_1:
      "This is a historic report. This means that an absence (and any RTW's or Alerts related to it) remain linked to the department the employee was in at the time of the absence.",
    HISTORIC_REPORT_PARAGRAPH_2:
      "For example, if an employee reported a 5 day absence in Department A in June, then moved to Department B in July, the 5 day absence will continue to contribute to Department A's June total, and not Department B's",
    CURRENT_REPORT: "Current Report",
    CURRENT_REPORT_PARAGRAPH_1:
      "This is a current report. This means that all absences are displayed based upon the department an employee is currently assigned to.",
    CURRENT_REPORT_PARAGRAPH_2:
      "For example, if an employee had 2 absences in Department A, and then moved to Department B, where they had a further 3 absences, then all 5 absences would appear if the report was run for Department B and 0 absences would appear if the report was run for Department A. This is because an employees absences (along with any RTW's or Alerts linked to them) travel with them to their new department in this report.",
    SAVE_YOUR_WORK_REMINDING_TEXT: "You will be logged out after 30 minutes. Save regularly.",
    MISSING_DEPARTMENT_WARNING:
      "The Department ID for which this report was saved is no longer available. Please select a new department.",
    NO_ACTIVITY_DATA: "There have been no new activities in the last 24 hours.",
    NO_REPORTS_MESSAGE: "You haven't created any reports yet. When you do, they will appear here.",
    NO_EMPLOYEES_MESSAGE: "No employees match your search criteria.",
    EMPLOYEE_CONFIDENTIAL_INTOFRMATION:
      "Employee records may contain confidential information and should be handled with care.",
    EMPLOYEE_PERMISSION_INFORMATION:
      "You are only permitted to access employee records to fulfil your management responsibilities.",
    EMPLOYEE_SURROUNDINGS_WARNING:
      "Be aware of your surroundings when accessing any employee records.",
    EMPLOYEE_ACCESS_INFORMATION:
      "Access to employee records is logged for security and auditing purposes.",
    REPORT_CONFIDENTIAL_INFORMANTIOM:
      "This report contains potentially sensitive or confidential information.",
    REPORT_SECURITY_INFORMANTIOM: "Please ensure that you store it in a safe location.",
    REPORT_SHARE_WARNING: "Only share this report with people authorised to see the information.",

    // Tasks help panel
    TASKS_INTRODUCTION:
      "The task queue gathers all your absence management actions into one location. Here you can access tasks such as Return to Work Interviews, Wellbeing Referrals and Absence Monitoring Reviews. Check in regularly to stay on top of things.",
    HEADLINE_STATISTICS: "Headline Statistics",
    TASKS_INSTRUCTIONS: "Tasks Instructions",
    TASKS_OUTSTANDING_DESCRIPTION:
      "This is the total number of outstanding tasks you need to complete.",
    TASKS_RTW_DESCRIPTION:
      "This shows how many of your outstanding tasks are Return to Work (RTW) Interviews.",
    TASKS_ABSENCE_MONITORING_REVIEWS_DESCRIPTION:
      "This shows how many of your outstanding tasks are Absence Monitoring Reviews. They will only appear if this feature has been enabled by your organisation.",
    TASKS_WELLBEING_DESCRIPTION:
      "This shows how many of your outstanding tasks are Wellbeing Referrals. They will only appear if this feature has been enabled by your organisation.",
    TASKS_OVERDUE_DESCRIPTION:
      "This shows how many of your outstanding Tasks are overdue and have not been completed on-time. The Due Date for tasks is configured by your organisation in line with policies and procedures.",
    FILTERS_AND_SEARCH: "Filters & Search",
    SEARCH_BAR: "Search Bar",
    FILTER_QUEUE: "Filter Queue",
    PAGINATION: "Pagination",
    TASKS_SEARCH_BAR_DESCRIPTION:
      "If you are looking for a task connected to a specific employee, you can search for their surname. Your task queue will then refresh to only display tasks for employees with a surname that matches your search criteria.",
    TASKS_FILTER_QUEUE_DESCRIPTION:
      "You can filter your Task Queue to only show a specific task type.",
    TASKS_PAGINATION_DESCRIPTION:
      "If you have over 50 outstanding tasks they will appear across multiple pages. You can click through the different pages of your Task Queue by using the pagination bar at the bottom of the page.",
    TASKS_ID_DESCRIPTION: "This is the unique ID of the task.",
    TASKS_TYPE_DESCRIPTION: "This is the type of task, such as RTW Interview.",
    TASKS_EMPLOYEE_NAME_DESCRIPTION: "This is the name of the employee the task relates to.",
    TASKS_ABSENCE_ID_DESCRIPTION: "This is the unique ID of the absence the task relates to.",
    TASKS_ABSENCE_START_DATE_DESCRIPTION:
      "This is the Start Date of the absence the task relates to.",
    TASKS_DUE_DATE_DESCRIPTION:
      "This is the date by which you must complete the task to be compliant with your organisations policies and procedures.",
    TASKS_STATUS_DESCRIPTION: `This is the status of the task and will always show either "To Do", "Due Today" or "Overdue".`,
    TASKS_ACTION_DESCRIPTION: "Click on this button to open the task form.",
    TASK_FORM: "Task Form",
    TASKS_EMPLOYEE_DETAILS_DESCRIPTION:
      "The top of the task form shows details of the employee the task relates to.",
    TASKS_ABSENCE_DETAILS_DESCRIPTION:
      "This section provides information about the absence that created the task. The information shown will vary based on the task type.",
    TASKS_QUESTIONS_DESCRIPTION:
      "This section includes the questions you need to answer in order to complete the task. The questions will be different based upon the type of task.",
    TASKS_PRINT_FORM_DESCRIPTION: "This button lets you print off a copy of the task form.",
    TASKS_SAVE_DRAFT_DESCRIPTION:
      "Some tasks, such as Return to Work Interviews, let you save a draft and come back to it later. Doing so keeps the tasks in your queue and allows you to pick up where you left off next time.",
    TASKS_SUBMIT_DESCRIPTION:
      "This button will submit the task. Once submitted, the task will be saved and removed from your Task Queue. It can then be found in the employees record going forward.",
    TASKS_LATE_SUBMISSION_DESCRIPTION:
      "If you complete a task late, your organisation may require you to indicate the reason why. In these case a pop-up will appear requiring you to confirm why the task has been completed late.",

    // Absence details help panel
    ABSENCE_DETAILS_INTRODUCTIOM:
      "The Absences report enables you to view a list of absences that meet your chosen criteria. For each absence, you are shown one row of information, including the absence dates, reason and time lost. Clicking an absence will navigate you to the full absence record.",
    STANDART_REPORTS_INTRODUCTION:
      "These are pre-set reports provided by GoodShape. Once you run a standard report you are free to edit and save it as one of your own reports if you prefer.",
    MY_REPORTS_INTRODUCTION:
      "These are reports that you have created on the system. You can create as many as you like, and run, edit or update them whenever you want.",
    MOST_ABSENCES_CHART: "Most Absences by Department Chart",
    PERCENTAGE_ABSENCES_BY_LENGTH_CHART: "% Absences by Length Chart",
    PERCENTAGE_ABSENCES_BY_STAFF_GROUP_CHART: "% Absences by Staff Group",
    QUICK_FILTERS: "Quick Filters",
    EXPORT_BUTTON: "Export Button",
    FORMAT: "Format",
    ABSENCE_DETAILS_INSTRUCTIONS: "Absence Details Instructions",
    AD_MOST_ABSENCES_DESCRIPTION:
      "This chart shows which 4 departments have the most absences within your report results.",
    AD_ABSENCES_BY_LENGTHS_DESCRIPTION:
      "This chart shows what % of absences in your report are short or long term.",
    AD_ABSENCES_BY_STAFF_GROUP_DESCRIPTION:
      "This chart shows the % of absences in your report split by Staff Group (i.e. profession). It will appear blank if your organisation does not use the Staff Group feature.",
    QUICK_FILTERS_DESCRIPTION:
      "At the top of the Report Results table are Quick Filters. You can use these to update and refresh the report results.",
    EXPORT_BUTTON_DESCRIPTION: "The Report Results can be exported to Excel.",
    INCLUDE_EMPLOYEE_WITH_DISABILITY: "Include Employees with a Disability",
    CONSENT_WITHHELD_ONLY: "Consent Withheld Only",
    DATE_RANGE_DESCRIPTION: `You can select a pre-set date range for your report, such as "The Last 30 Days" or choose "Custom" to be able to select your own time period.`,
    FROM_DATE_DESCRIPTION:
      "This filter is used to determine the start date of the time period covered by the report.",
    TO_DATE_DESCRIPTION:
      "This filter is used to determine the end date of the time period covered by the report.",
    ABSENCE_STATUS_DESCRIPTION:
      "This filter allows you to exclude certain absences based upon their status, enabling you to view all absences, or only those that are Open for example.",
    ABSENCE_TYPE_DESCRIPTION:
      "This filter enables you to limit the report to only showing absences of a certain type, such as Medical.",
    ABSENCE_FILTER_DESCRIPTION: `This filter controls the logic used to identify absences to be included in your report. For example, if this is set as "That Started", then the report will return all absences with an absence start date within the time period covered by your report.`,
    WORK_RELATED_DESCRIPTION:
      "If this is set to Yes, the report will only include absences that the employee said were due to work related issues and incidents.",
    GREATER_THAN_DAYS_DESCRIPTION:
      "This filter is used in conjunction with the Day Type filter to let you limit the report to only showing absences greater than a certain length, such as 15 Working Days.",
    GRATER_THAN_DAY_TYPE_DESCRIPTION:
      "This filter is used in conjunction with the Days filter to let you limit the report to only showing absences greater than a certain length, such as 15 Working Days.",
    ABSENCE_LENGTH_DESCRIPTION:
      "This filter allows you to limit the report to only showing Short or Long term absences. The definition of a Long term absence is controlled by your organisation.",
    INCLUDE_LEAVERS_DESCRIPTION:
      "This filter lets you decide if ex-employees that meet your report criteria still appear in the report results. It defaults to no.",
    EMPLOYEE_WITH_DISABILITY_DESCRIPTION:
      "This filter lets you decide if you want to remove employees with a disability from the scope of your report. Note that employees will only be removed from the report if the disability status has been updated on their GoodShape record.",
    GENDER_DESCRIPTION:
      "This filter allows you to limit the report results to all employees, or only those assigned a specific gender.",
    CONSENT_WITHHELD_DESCRIPTION:
      "This filter allows you to limit the report to only showing absences where the employee refused to share the absence reason. It defaults to no.",
    ABSENCE_REASONS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing absence classified with specific absence reasons. You can select multiple options for this filter.",
    STAFF_GROUPS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing absences reported by employees assigned to specific Staff Groups. You can select multiple options for this filter.",
    AGE_GROUPS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing absences reported by employees in certain Age Groups. You can select multiple options for this filter.",
    EMPLOYEE_REF_DESCRIPTION:
      "This is the unique reference number of the employee. Clicking on the number will open the employee record in a new tab on your browser.",
    DEPARTMENT_DESCRIPTION:
      "This is the department the employee works in. If they work in two or more departments, both names will appear, separated by a comma.",
    AD_START_DATE_DESCRIPTION: "This is the start date and time of the employee's absence.",
    AD_LAST_ABSENCE_DAY_DESCRIPTION:
      "This is the last scheduled workday that the employee was absent for, before returning to work.",
    AD_RTW_DATE_DESCRIPTION:
      "This is the date the employee is expected to return to work for Open Absences. It is the actual return to work date  for Closed Absences.",
    AD_DAYS_LOST_DESCRIPTION:
      "This is the total number of Working Days Lost the employee missed due to the absence.",
    AD_RESULTS_ABSENCE_TYPE_DESCRIPTION:
      "This is the Type of absence, which will always be Medical (i.e. Sickness) or Non-Medical (i.e. non-sickness related absence).",
    AD_ABSENCE_REASON_DESCRIPTION: `This is the Reason  for the employee’s absence. If the employee did not consent to sharing the reason, “Consent Withheld” will appear.`,
    AD_STATUS_DESCRIPTION:
      "This is the status of the absence. An absence is considered Open if it's return to work date is in the future. An absence is Overdue if the return to work date is in the past and the absence has not been closed. An absence is considered Closed if the return to work date is in the past, and the employee has closed the absence.",
    AD_ABSENCE_ID_DESCRIPTION:
      "This is the unique ID of the absence and is the number you can quote if you need to contact GoodShape with a query about the absence.",

    // Alert Details help panel
    ALERT_DETAILS_INTRODUCTION:
      "The Alerts report enables you to view a list of absence policy alerts that have been triggered by your employees within a given time period. For each alert, you are shown one row of information, including the alert name and date triggered.",
    ALERT_DETAILS_INSTRUCTIONS: "Alert Details Instructions",
    ALERT_TOP_5_TRIGGERED_POSITIONS_DESCRIPTION:
      "This chart shows the top 5 positions (i.e. job titles) that have triggered the most alerts in your report results. It is designed to give an indication of which job occupations are triggering the most alerts.",
    ALERT_TOP_5_ALERTS_TRIGGERED_DESCRIPTION:
      "This chart shows the 5 alerts that have been triggered the most within your report results, and what % of total alerts triggered they account for. If your organisation has less than 5 alerts set-up on the platform, then all alerts will be shown.",
    ALERT_TYPES_DESCRIPTION:
      "This filter lists all of the alerts that are set-up for your organisation. You can select multiple alerts and the report will only show employees that have triggered one or more of your chosen alerts.",
    ALERT_EMPLOYEE_WITH_DISABILITY_DESCRIPTION:
      "This filter lets you decide if you want to remove employees with a disability from the scope of your report. Note: Employees will only be removed from the report if the disability status has been updated on their GoodShape record.",
    ALERT_STAFF_GROUPS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing alerts triggered by employees assigned to specific Staff Groups. You can select multiple options for this filter.",
    ALERT_AGE_GROUPS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing alerts triggered by employees in certain Age Groups. You can select multiple options for this filter.",
    POSITION_DESCRIPTION:
      "This is the position assigned to the employee (i.e. job title). If they have two or more positions, both names will appear, separated by a comma.",
    ALERTS_TRIGGERED_DESCRIPTION:
      "This is the name of the alert that was triggered by the employee.",
    DATE_TRIGGERED_DESCRIPTION: "This is the date and time that the employee triggered the alert.",
    ABSENCE_DATES_DESCRIPTION:
      "This is the Absence Start Date of the absence that triggered the alert.",
    STAFF_GROUPS_DESCRIPTION:
      "This is the Staff Group that the employee has been assigned to. If your organisation does not use Staff Groups the column will appear blank.",
    DISABILITY_DESCRIPTION: `This is the disability status of the employee. "Yes" means the employee has a disability according to their GoodShape record.`,
    AGE_BRACKETS_DESCRIPTION: "This is the age bracket that the employee falls into.",
    ABSENCE_REASON_DESCRIPTION: `This is the absence reason classified against the absence that triggered the alert. It will show as "Consent Withheld" if the employee did not agree to let their absence reason be known.`,
    ABSENCE_STATUS_DESCRIPTION: "This is the status of the absence that triggered the alert.",
    RESULT_GENDER_DESCRIPTION:
      "This is the Gender assigned to the employee in their GoodShape record.",

    // RTW Interviews help panel
    RTW_INTRODUCTION:
      "The Return to Work Interviews report enables you to view a list of return to work interviews (RTW) that meet your chosen criteria. For each interview, you are shown one row of information, including the absence dates, interview due date and status.",
    RTW_INSTRUCTIONS: "RTW Interviews instructions",
    LAST_RTW_REASONS_DESCRIPTION:
      "This pie chart shows the % split of reasons for why managers submitted RTW Interviews late. Note: This chart does not display if the report is filtered to only show outstanding RTW Interviews.",
    RTW_COMPLETED_ON_TIME_DESCRIPTION:
      "This pie chart shows the % split between RTW Interviews completed on-time, or late, during the period covered by the report. Note: This chart does not display if the report is filtered to only show outstanding RTW Interviews.",
    RTW_FROM_DATE_DESCRIPTION:
      "This filter is used to determine the start date of a custom time period to be covered by the report.",
    RTW_TO_DATE_DESCRIPTION:
      "This filter is used to determine the end date of a custom time period to be covered by the report.",
    RTW_STATUS_DESCRIPTION:
      "This filter allows you to choose the type of RTW Interviews you want to see listed, such as those that are outstanding, or have been completed late. You can only choose one status each time you run the report.",
    RTW_ABSENCE_TYPE_DESCRIPTION:
      "This filter enables you to limit the report to only show absences of a certain type, such as Medical.",
    RTW_ABSENCE_LENGTH_DESCRIPTION:
      "This filter allows you to limit the report to showing RTW Interviews for only Short or Long term absences. The definition of a Long term absence is controlled by your organisation.",
    RTW_MY_FORMS_DESCRIPTION:
      "This filter lets you limit the results to only the RTW Interviews that were specifically assigned to you.",
    RTW_ABSENCE_REASONS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing absences classified with specific absence reasons. You can select multiple options for this filter.",
    RTW_DUE_DATE_DESCRIPTION:
      "This is the date the return to work interview was due to be completed in order to be compliant with your organisations policies.",
    RTW_DATE_COMPLETED_DESCRIPTION:
      "This is the actual date that the RTW Interview was completed. It is populated based on the date and time entered by the manager on the RTW Interview form. Note: This field will appear blank if the RTW Interview was not completed.",
    RTW_COMPLETED_BY_DESCRIPTION:
      "This is the name of the individual that submitted the completed RTW Interview form. This field will appear blank if the RTW Interview was not completed.",
    RTW_HOURS_TO_COMPLETE_DESCRIPTION:
      "This is a count of how many hours passed between the Return to Work date and time of the absence, and the date and time that the RTW Interview was completed.",
    RTW_COMPLIANT_DESCRIPTION: `This will show "Yes" if the RTW form was completed by the due date, or "No" if it was completed late.`,
    RTW_STAFF_GROUPS_DESCRIPTION:
      "This filter allows you to limit the report results to only showing absences reported by employees assigned to specific Staff Groups. You can select multiple options for this filter.",
    RTW_INCLUDE_LEAVERS_DESCRIPTION:
      "This filter lets you decide if ex-employees that meet your report criteria still appear in the report results.",

    ACTIVITIES_INTRODUCTION:
      "The Activity feed gives you a real-time update of all absence related activity in your area of the organisation. It will list any activities connected to employees or departments your organisation has granted you access to view, and will show activities that have taken place in a rolling 24-hour period.",
    ACTIVITIES_INSTRUCTIONS: "Activities Instructions",

    ACTIVITIES_NEW_AND_UPDATED_ABSENCES:
      "A count of how many absences have been reported or updated in the last 24 hours.",
    ACTIVITES_CLOSED_ABSENCES:
      "A count of how many absences have been closed in the last 24 hours.",
    ACTIVITIES_ALERTS_AND_REVIEWS:
      "A count of how many Absence Policy Alerts have been triggered, and how many Absence Monitoring Reviews have been completed, in the last 24 hours.",
    ACTIVITIES_MANAGER_UPLOADS:
      "A count of how many Notes have been added, and how many Documents have been uploaded, to employee records in the last 24 hours.",
    ACTIVITIES_RTW_INTERVIEWS:
      "A count of how many Return-to-Work Interviews have been completed in the last 24 hours.",
    ACTIVITIES_WHEN_DESCRIPTION:
      "This column indicates when the activity took place. The most recent activities appear at the top.",
    ACTIVITIES_ACTIVITY_DESCRIPTION: "This column indicates the type of activity.",
    ACTIVITIES_DETAILS_DESCRIPTION:
      "This column provides details about the activity, so you know who did what.",
    ACTIVITIES_VIEW_DESCRIPTION:
      "Clicking this button will navigate you to the absence the activity relates to.",

    // Health Reports
    HEALTH: "Health",
    WORKFORCE_HEALTH: "Workforce Health",
    CARE_PLANS: "Care Plans",
    WELLBEING_ADVICE_TITLE: "Wellbeing Advice",
    NURSE_ASSESSMENTS: "Nurse Assessments",
    CONDITIONS: "Conditions",
    PERCENTAGE_OF_STAFF: "% of Staff",
    GENDER_MALE: "Gender: Male",
    GENDER_FEMALE: "Gender: Female",
    GENDER_OTHER: "Gender: Other",
    AGE_RANGE_OF: "Age: {range}",
    BY_CATEGORY: "By Category",
    BY_ABSENCE_REASON: "By Absence Reason",
    BY_TIME_OF_DAY: "By Time of Day",
    BY_ACTIVITY: "By Activity",
    ALL_ADVICE: "All Advice",
    ILLNESS_ADVICE: "Illness Advice",
    MIND_ADVICE: "Mind Advice",
    CRISIS_ADVICE: "Crisis Advice",
    CATEGORY: "Category",
    SUB_CATEGORY: "Sub-Category",
    TOPIC: "Topic",
    TOTAL_VIEWS: "Total Views",
    MALE_STAFF: "Male Staff",
    FEMALE_STAFF: "Female Staff",
    OTHER_STAFF: "Other Staff",
    BY_HEALTH_ISSUE: "By Health Issue",
    BY_DEPARTMENT: "By Department",
    BY_ABSENCE_LENGTH: "By Absence Length",
    BY_AGE_GROUP: "By Age Group",
    CURRENT_TREATMENT: "Current Treatment",
    SELF_CARE: "Self-Care",
    GP_OR_DENTIST: "GP or Dentist",
    ONE_ONE_ONE_SERVICE: "111 Service",
    WALK_IN_CLINIC: "Walk-in Clinic",
    A_AND_E: "A&E",
    EMERGENCY: "Emergency",
    CONTINUE_TREATMENT: "Continue Treatment",
    HEALTH_LAST_12_MONTHS: "Last 12 Months",

    // Providers Report
    PROVIDERS: "Providers",
    PROVIDER_MANAGEMENT: "Provider Management",
    PROVIDER_NAME: "Providers Name",
    COVERAGE: "Coverage",
    VIEWS: "Views",
    REVIEWS: "Reviews",
    RESPONSE_TIME: "Response Time",
    HELPFULNESS: "Helpfulness",
    CUSTOMER_SERVICE: "Customer Service",
    NO_REVIEWS: "No Reviews",
    HEALTH_ISSUE_COVERAGE: "Health Issue Coverage",
    PERCENT_ISSUE_COVERED: "% Issue Covered",
    PERCENT_ISSUE_NOT_COVERED: "% Issue Not Covered",

    // KPI Compliance Report
    EMPLOYEE_STATUS: "Employee Status",
    KPI_COMPLIANCE: "KPI Compliance",
    BY_MANAGER: "By Manager",
    ABSENCE_REVIEWS: "Absence Reviews",
    ACTION_TAKEN: "Action Taken",
    NO_ACTION_TAKEN: "No Action Taken",
    ACTION_TAKEN_PERCENTAGE: "% Action Taken",
    GROUP_KPI_BY_MANAGER: "Line Manager",
    GROUP_KPI_BY_DEPARTMENT: "Department",
    GROUP_KPI_BY_ABSENCE_REASON: "Absence Reason",

    // Health help panels
    NURSE_ASSESSMENTS_INSTRUCTIONS: "Nurse Assesstments Instructions",
    OUTCOMES: "Outcomes",
    NURSE_ASSESSMENTS_INTRODUCTION:
      "A Nurse Assessment is an advice call between an employee and a member of the GoodShape clinical team. The purpose of the call is to provide employees with confidential advice and support to help them with a health issue. Employees can book a Nurse Assessment at any time of day, even if they are not absent from work. The outcomes of Nurse Assessments are compiled into anonymised, aggregated reports to help you understand the health issues for which your employees needed support.",
    CONTINUE_TREATMENT_DESCRIPTION:
      "The employee already had a treatment plan from another healthcare professional and the GoodShape clinician reinforced that it should be followed.",
    SELF_CARE_DESCRIPTION:
      "The employee’s symptoms were mild and the GoodShape clinician provided advice and guidance on how they can self-manage their symptoms and general health.",
    GP_OR_DENTIST_DESCRIPTION:
      "The employee’s symptoms were severe enough for the GoodShape clinician to recommend further triage and assessment from either their GP or Dentist.",
    ONE_ONE_ONE_SERVICE_DESCRIPTION:
      "The employee was advised to contact the National Health 111 Service to go through more detailed triaging and signposting for ongoing support.",
    WALK_IN_CLINIC_DESCRIPTION:
      "The employee’s symptoms were concerning but not considered life threatening, and the employee was directed to their nearest walk-in-clinic so that their symptoms could be reviewed in person by a suitable healthcare professional.",
    EMERGENCY_DESCRIPTION:
      "The employee’s symptoms were a cause for great concern, with a possibly life-threatening risk. The employee was advised to call 999. If they were unable to do so, the GoodShape clinician contacted the emergency services and requested for an ambulance to be sent to the employee’s location if necessary.",
    NURSE_ASSESSMENT_RECOMMENDATION_ONE:
      "Always encourage employees to make use of the clinical services GoodShape make available. The more an employee engages with the support on offer, the more advice and help they will receive.",
    NURSE_ASSESSMENT_RECOMMENDATION_TWO:
      "The Health Issues that appear at the top of the report are the ones your employees have been seeking the most help with. Include these issues in your ongoing health and wellbeing initiatives to ensure that you're providing employees with relevant support.",
    RECOMMENDATIONS: "Recommendations",
    REFLECT_ON_INITIATIVES: "Reflect on Initiatives",
    PROMOTE_ENGAGEMENT_DESCRIPTION:
      "Always encourage employees to make use of the clinical services GoodShape make available. The more an employee engages with the support on offer, the more advice and help they will receive.",
    REFLECT_ON_INITIATIVES_DESCRIPTION:
      "The Health Issues that appear at the top of the report are the ones your employees have been seeking the most help with. Include these issues in your ongoing health and wellbeing initiatives to ensure that you're providing employees with relevant support.",

    WORK_FORCE_INSTRUCTIONS: "Work Force Instructions",
    ANALYZE_DATA: "Analyse Data",
    WORK_FORCE_INTRODUCTION:
      "When an employee engages with the GoodShape platform they have the option to share information about their health and wellbeing. This information is kept strictly confidential, and is used only in anonymised, aggregated reports designed to give you high level insights into the health needs of your workforce.",
    REPORT_TYPES: "Report Types",
    CONDITION_DESCRIPTION:
      "This report shows how many employees have pre-existing medical conditions that they must manage and live with on a day-to-day basis. The most common conditions are shown at the top.",
    MEDICATION_DESCRIPTION:
      "This report shows how many employees must regularly take specific medications as part of managing a health issue. The most common medications are shown at the top.",
    ALLERGIES_DESCRIPTION:
      "This report shows how many employees have specific allergies. The most common allergies are shown at the top. ",
    VACCINATIONS_DESCRIPTION:
      "This report shows how many employees have had specific vaccinations. The most common vaccinations are shown at the top. ",
    ANALYZE_DATA_DESCRIPTION:
      "We recommend that you use this data as an input when developing your Health and Wellbeing strategies.",

    CATEGORIES: "Categories",
    CARE_PLANS_INTRODUCTION:
      "A Care Plan is a list of daily activities that employees are encouraged to perform to manage their wellbeing while absent. Care Plans are presented to absent employees via the GoodShape app. Completed care plan activities are aggregated together into anonymised reports to provide insight into employee wellbeing activity.",
    CARE_PLANS_INSTRUCTIONS: "Care Plans Instructions",
    REST: "Rest",
    HYDRATION: "Hydration",
    FOOD: "Food",
    MIND: "Mind",
    REST_DESCRIPTION:
      "These are activities focused on ensuring employees get the rest and recovery they need.",
    HYDRATION_DESCRIPTION:
      "Different types of illness require different hydration patterns and levels of water consumption. These activities advise employees on what to drink, and when, to take care of their health.",
    FOOD_DESCRIPTION:
      "These activities focus on advising employees about foods to avoid, as well as foods that may help with their current symptoms.",
    EXCERCISE_DESCRIPTION:
      "These activities focus on physical exercise, such as walking, running, workout routines. Employees are advised to only complete these activities if they are able.",
    MIND_DESCRIPTION:
      "These activities focus on mental health and often take the form of short games or exercises that focus on positivity and mindfulness.",
    SELF_CARE_PLANS_DESCRIPTION:
      "These activities focus on caring for physical ailments, such as dressing wounds, washing eyes or handling rashes and infections.",
    ENCOURAGE_ENGAGEMENT: "Encourage Engagement",
    COMMUNICATION_INPUTS: "Communication Inputs",
    ENCOURAGE_ENGAGEMENT_DESCRIPTION:
      "Always promote care plans to employees and encourage them to take care of their wellbeing while absent. ",
    COMMUNICATION_INPUTS_DESCRIPTION:
      "The By Activity report shows the most popular activities that employees have completed. When organising employee communications or workshops about health and wellbeing, consider including content to positively reinforce these activities.",

    CRISIS: "Crisis",
    ILLNESS: "Illness",
    WELLNESS: "Wellness",
    WELLBEING_ADVICE_INTRODUCTION:
      "The GoodShape app includes an advice library featuring a range of physical and mental health topics. Employees can view this content at any time, even when not absent from work. Each time a piece of content is viewed a log is kept for including in these anonymised, aggregated reports.",
    WELLBEING_ADVICE_INSTRUCTIONS: "Wellbeing Advice Instructions",
    MENTAL_HEALTH_SUPPORT: "Mental Health Support",
    ADVICE_CATEGORIES: "Advice Categories",
    WELLBEING_ILLNESS_DESCRIPTION:
      "Advice for the most common causes of absence, including coughs, colds, gastrointestinal issues, back problems etc.",
    WELLBEING_MIND_DESCRIPTION:
      "Advice for a variety of mental health issues, such as stress, anxiety, depression, self-confidence, substance abuse and many more.",
    WELLBEING_ALLERGIES_DESCRIPTION:
      "Advice for managing a variety of allergies, such as food, chemicals, insect bites, animal fur, medications and many more.",
    WELLBEING_CRISIS_DESCRIPTION:
      "Advice for reacting to several crisis events, such as feelings of suicidal ideation, accidental overdose, and being a victim of physical abuse.",
    WELLBEING_WELLNESS_DESCRIPTION:
      "Advice for maintaining a healthy lifestyle, with content on topics such as maintaining a healthy heart, being safe in the sun and back care.",
    WELLBEING_ENCOURAGE_ENGAGEMENT_DESCRIPTION:
      "Always encourage employees to make use of the clinical services GoodShape make available. The more an employee engages with the support on offer, the more advice and help they will receive.",
    WELLBEING_MENTAL_HEALTH_SUPPORT_DESCRIPTION:
      "Review the most viewed topics within the Mind Advice category. This will give you some insight into the mental health struggles your employees are coping with. This information could then be factored into any mental health related strategies and initiatives you may be planning.",

    NAVIGATOR: "Navigator",
    GOODSHAPE_WITH_PREF: "GoodShape{pref}",
    GOODSHAPE_NAVIGATOR_DESCRIPTION:
      "Track employee referrals between GoodShape and external treatment providers, such as Occupational Health and Physiotherapy. The key objective is to help return employees to work as early, and safely, as possible.",
    GOODSHAPE_HEALTH_OVERVIEW_DESCRIPTION:
      "24/7 clinical advice and support designed to help employees return to health, and then to work. These reports summarise the volume of engagement with each of GoodShape’s clinical interventions.",

    // Outcomes report
    REFERRAL_OUTCOMES: "Referral Outcomes",
    OUTCOMES: "Outcomes",
    BY_DEPARTMENT: "By Department",
    BY_TRIGGER: "By Trigger",
    BY_ABSENCE_REASON: "By Absence Reason",
    BY_ABSENCE_LENGTH: "By Absence Length",
    DID_NOT_RETURN: "Did Not Return",
    PHASED_RETURN: "Phased Return",
    RETURNED_REDUCED_DUTIES: "Returned on Reduced Duties",
    RETURNED_FULL_DUTIES: "Returned on Full Duties",
    // Manager KPI
    MANAGER_KPIS: "Manager KPIs",
    REFERRALS_ACTIONED: "Referrals Actioned",
    ON_TIME: "On-Time",
    COMPLIANCE_PERCENTAGE: "% Compliance",
    APPROVED_PERCENTAGE: "% Approved",
    MOST_REFERRALS_ACTIONED: "Most Referrals Actioned",
    MOST_APPROVALS: "Most Approvals",
    HIGHEST_COMPLIANCE: "Highest Compliance",
    ORDER_BY: "Order by",

    // Absence Monitoring form
    DECISION_MADE: "Decision Made",
    NEW_ABSENCE_MONITORING_LEVEL: "New Absence Monitoring Level",
    EFFECTIVE_FROM_DATE: "Effective From Date",
    SET_REVIEW_DATE: "Set Review Date",
    BLOCKED_TEMPORARY: "Temporary Locked",
    RTW_INTERVIEW_OVERDUE_NOTIFICATION: "RTW Interview Overdue Notification",

    // Absence Details Cover Text
    AD_COVER_CURRENT_OPEN_TITLE:
      "A list of all currently absent employees, their reason for absence, and expected return to work date.",
    AD_COVER_STARTED_LAST_WEEK:
      "Details of every absence that started in the last week, including both open and closed absences.",
    AD_COVER_MENTAL_LAST_YEAR:
      "Details of every mental health related absence in the last year, including stress, depression, anxiety, and psychological disorders.",
    AD_COVER_MUSCULOSKELETAL_LAST_YEAR:
      "Details of every musculoskeletal absence in the last year, including back problems, neck issues, upper limb and lower limb injuries.",
    AD_COVER_NEW_TODAY: "A list of all absences reported since midnight today.",
    AD_COVER_CLOSED_TODAY:
      "A list of absences for which the employee was expected to return to work today.",
    ABSENCES_COVER_STARTED_LAST_MONTH:
      "Details of every absence reported by employees in the last 30 days.",
    ABSENCES_COVER_STARTED_LAST_YEAR:
      "Details of every absence reported in the last year. Due to the volume of data, this report will take a long time to load.",

    // Alert Details Cover Text
    ALERTS_TODAYS: "Details of employees that have triggered alerts today.",
    ALERTS_LAST_WEEK: "Detail of employees that have triggered an alert in the last week.",
    ALERTS_LAST_MONTH: "Detail of employees that have triggered an alert in the last 30 days.",
    ALERTS_LAST_QUARTER: "Detail of employees that have triggered an alert in the last 90 days.",

    // Absence Rate Trends Cover Text
    ART_MONTHLY_TRENDS_LAST_YEAR:
      "Monthly trend report showing the hours lost to absence as a % of total contracted hours available.",
    ART_DAYS_LOST_LAST_YEAR:
      "Total working days lost as a monthly trend, broken down by hierarchy and including all types of absence.",
    ART_ABSENCE_SPELLS_LAST_YEAR:
      "A count of distinct absences that  were started each month, regardless of how long they lasted.",
    ART_DLPE_LAST_YEAR:
      "The average days lost per employee (DLPE), calculated by dividing the Working Days Lost by the available employee Headcount.",
    ART_BV12_FTE_LAST_YEAR:
      "Designed for local authorities, showing the FTE resource available as a monthly trend.",
    ART_BV12_SCORE_LAST_YEAR:
      "Shows the Best Value Indicator 12 (BV12) score on a monthly basis. Designed for local authorities.",
    ART_WORKING_HOURS_LAST_YEAR:
      "Monthly trend showing the total hours lost due to absence, calculated by adding up the total time lost of all employees absent in the month.",
    ART_WORKING_HOURS_AVAILABLE_LAST_YEAR:
      "Total hours available, calculated by adding together the contracted hours of all active employees and multiplying them by the number of weeks in each month.",
    ART_WORKING_DAYS_AVAILABLE_LAST_YEAR:
      "Monthly trend showing the total working days available each month.",
    ART_HEADCOUNT_LAST_YEAR:
      "Shows employee headcount per month. It is calculated by averaging the headcount at the start and end of each month.",
    ART_COST_OF_ABSENCE_LAST_YEAR:
      "The estimated cost of absence per month, calculated by multiplying the working days lost by the average daily cost of absence. (£INSERT VALUE)",

    // RTW Cover Text
    RTW_ALL_OUTSTANDING_INTERVIEWS:
      "Details of all outstanding return to work interviews that have not yet been completed by line managers.",
    RTW_COMPLETED_LAST_WEEK:
      "A list of all RTW interviews completed in the last week, with details of who completed the interview and when.",
    RTW_COMPLETED_LAST_MONTH:
      "A list of all RTW interviews completed in the last 30 days, with details of who completed the interview and when.",
    RTW_COMPLETED_LAST_SIX_MONTH:
      "Details of all return to work interviews that were expired and cancelled because they were not completed by the line manager.",

    // Absence Reason Cover Text
    AR_WORKING_DAYS_LOST_LAST_YEAR: "Total working days lost per month per absence reason.",
    AR_ABSENCE_SPELLS_LAST_YEAR:
      "A count of distinct absences started per absence reason per month.",
    AR_ABSENCE_LENGTH_LAST_YEAR:
      "The average length of a single absence per reason. Calculated using the average days lost of all absences started in each month.",
    AR_RTW_COMPLIANCE_LAST_YEAR:
      "RTW Compliance for each reason, helping you to identify which reasons your managers are best or worst at tackling.",
    AR_DLPE_LAST_YEAR:
      "The average days lost per employee (DLPE) per reason, calculated by dividing the Working Days Lost by the available employee Headcount.",
    AR_COSTS_LAST_YEAR:
      "Estimated cost of absence per month, calculated by multiplying the working days lost by the average daily cost of absence. (£INSERT VALUE)",
    AR_SHORT_SPELLS_LAST_YEAR:
      "A count of distinct short term absences started per absence reason per month.",
    AR_LONG_SPELLS_LAST_YEAR:
      "A count of long-term absences started per absence reason per month. Long term absence definition: INSERT NUMBER, INSERT TYPE DAYS)",

    // Compliance Trends Cover Text
    CT_RTW_COMPLIANCE_LAST_YEAR:
      "Monthly trend showing what % of RTW Interviews completed each month were done on-time in the last year.",
    CT_RTW_COMPLIANCE_LAST_TWO_YEARS:
      "Monthly trend showing what % of RTW Interviews completed each month were done on-time in the last 2 years.",
    CT_ABSENCE_MONITORING_BY_DEPARTMENT:
      "Monthly trend showing how many absence review meetings were completed on time after an employee triggered an absence policy alert.",
    CT_ABSENCE_MONITORING_BY_MONITORING:
      "Monthly trend showing how many absence review meetings were completed on time, looking over a 2 year period.",

    // Employee Focus List Cover Text
    EFL_TOP_WORKING_DAYS_LAST_YEAR:
      "The 100 employees who have had the most time lost to absence in the last 12 months.",
    EFL_TOP_ABSENCE_SPELLS_LAST_YEAR:
      "The 100 employees who had the highest number of absence spells in the last 12 months.",
    EFL_TOP_MENTAL_HEALTH_ABSENCES_LAST_YEAR:
      "The 25 employes who had the most mental health related absences last year, such as stress, depression, anxiety, and psychological disorders.",
    EFL_TOP_WORK_ABSENCES_LAST_YEAR:
      "The 25 employees who had the highest number of absences that they claimed to be caused by work.",
    EFL_TOP_COVID_ABSENCES_LAST_YEAR:
      "The 500 employees with the most COVID-19 related absences in the last 12 months.",
    EFL_LEAST_ABSENCES_LAST_YEAR:
      "The 100 employees who had this least number of absences last year. Includes employees who had no absence as well.",

    // Department Focus List Cover Text
    DFL_TOP_ABSENCE_RATE_LAST_YEAR:
      "The 10 departments with the highest absence levels in the last year.",
    DFL_TOP_WORKING_DAYS_LAST_YEAR:
      "The 10 departments which day the most days lost due to absence in the last year.",
    DFL_TOP_ABSENCE_SPELLS_LAST_YEAR:
      "The 10 departments that had the highest number of absences reported in the last year.",
    DFL_TOP_MENTAL_HEALTH_ABSENCES_LAST_YEAR:
      "The 25 departments that had the most mental health absences last year, such as stress, depression, anxiety, and psychological disorders.",
    DFL_TOP_RTW_COMPLIANCE_LAST_YEAR:
      "The 50 departments that are the best at completing return to work interviews on-time.",
    DFL_LOWEST_RTW_COMPLIANCE_LAST_YEAR:
      "The 50 departments that are the poorest at completing return to work interviews on-time.",
    DFL_TOP_COVID_ABSENCES_LAST_YEAR:
      "The 100 departments that have had the most COVID absences in the last year.",

    // Manager Focus List Cover Text
    MFL_TOP_RTW_COMPLIANCE:
      "The 10 managers who have submitted the highest % of compliant return to work interviews.",
    MFL_LOWEST_RTW_COMPLIANCE:
      "The 10 managers who have submitted the lowest % of compliant return to work interviews.",
    MFL_TOP_MOST_LOGINS: "The 10 managers who have logged into GoodShapeCentral the most.",
    MFL_TOP_ACTIONS: "The managers who have the most outstandings actions in their task queue.",

    // Absence Monitoring Cover Text
    AM_EMPLOYEE_STATUS:
      "The current status of each employee that has been entered into the absence monitoring process, along with details of the manager who placed them there.",
    AM_UNPROCESSED_EMPLOYEES:
      "A list of employees that have never been entered into the Absence Monitoring process, suggesting that they have had low absence levels.",
    AM_ALERT_REVIEWS:
      "Details of outstanding absence monitoring reviews tasks that have not yet been completed.",

    // KPI Compliance Cover Text
    KPI_BY_MANAGER:
      "The number of completed reviews per manager, with a breakdown by compliance and outcome.",
    KPI_BY_DEPARTMENT:
      "The number of completed reviews per department, with a breakdown by compliance and outcome.",
    KPI_BY_ABSENCE_REASON:
      "The number of completed reviews per absence reason, with a breakdown by compliance and outcome.",

    // Workforce Health Cover Text
    WH_CONDITIONS:
      "The most common medical conditions that your employees live with, and which impact their wellbeing.",
    WH_MEDICATIONS: "The most common medications that are regularly taken by your employees.",
    WH_ALLERGIES: "The most common allergies suffered by your employees.",
    WH_VACCINATIONS: "The most common vaccinations that your employees have had.",

    // Care Plans Cover Text
    CP_BY_CATEGORY:
      "Completed activities split by type: Rest, Hydration, Food, Self-Care, Mind and Physical.",
    CP_BY_ABSENCE_REASON:
      "Completed activities split by absence reason, showing which issues see the most employee activity.",
    CP_BY_TIME_OF_DAY:
      "Completed activities split by time of day: Morning, afternoon, evening and night.",
    CP_BY_ACTIVITY:
      "Completed activity split by the type of activity the most common actions that employees have performed.",

    // Wellbeing Advice Cover Text
    WA_ALL_ADVICES:
      "The most common advice that your employees have been accessing via the GoodShape app.",
    WA_ILLNESS_ADVICE:
      "The most common advcie your employees have been accessinbg for illnesses, such as coughs, colds, skin problems, aches and pains.",
    WA_MIND_ADVICES:
      "The most common mental health related advice your employees have been accessing, such as for stress, anxiety, sleep patterns and depression.",
    WA_CRISIS_ADVICES:
      "The most common crisis advice that has been accessed, such as for help with suicidal ideation, stroke and abuse.",

    // Nurse Assessments Cover Text
    NA_BY_HEALTH_ISSUES:
      "Completed appointments between employees and the GoodShape clinical team, split by issue and outcome.",
    NA_BY_DEPARTMENT: "Completed appointments completed split by department and outcome.",
    NA_BY_ABSENCE_LENGTH: "Completed appointments split by absence length and outcome.",
    NA_BY_AGE_GROUP: "Completed appointments split by employe age group and outcome.",
  },
};
